var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest;
var init_iconsManifest = __esm({
  "../../node_modules/@react-icons/all-files/lib/esm/iconsManifest.js"() {
    "use strict";
    IconsManifest = [
      {
        "id": "fa",
        "name": "Font Awesome",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
      },
      {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
      },
      {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
      },
      {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
      },
      {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
      },
      {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
      },
      {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
      },
      {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
      },
      {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
      },
      {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
      },
      {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
      },
      {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
      },
      {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
      },
      {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
      },
      {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
      },
      {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/refactoringui/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
      },
      {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
      },
      {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License"
      },
      {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License"
      },
      {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
      },
      {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
      }
    ];
  }
});

// ../../node_modules/@react-icons/all-files/lib/esm/iconContext.js
import React from "react";
var DefaultContext, IconContext;
var init_iconContext = __esm({
  "../../node_modules/@react-icons/all-files/lib/esm/iconContext.js"() {
    "use strict";
    DefaultContext = {
      color: void 0,
      size: void 0,
      className: void 0,
      style: void 0,
      attr: void 0
    };
    IconContext = React.createContext && React.createContext(DefaultContext);
  }
});

// ../../node_modules/@react-icons/all-files/lib/esm/iconBase.js
import React2 from "react";
function Tree2Element(tree) {
  return tree && tree.map(function(node12, i) {
    return React2.createElement(node12.tag, __assign({
      key: i
    }, node12.attr), Tree2Element(node12.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return React2.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return React2.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React2.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? React2.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
var __assign, __rest;
var init_iconBase = __esm({
  "../../node_modules/@react-icons/all-files/lib/esm/iconBase.js"() {
    "use strict";
    init_iconContext();
    __assign = function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    __rest = function(s, e) {
      var t = {};
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
            t[p[i]] = s[p[i]];
        }
      return t;
    };
  }
});

// ../../node_modules/@react-icons/all-files/lib/esm/index.js
var esm_exports = {};
__export(esm_exports, {
  DefaultContext: () => DefaultContext,
  GenIcon: () => GenIcon,
  IconBase: () => IconBase,
  IconContext: () => IconContext,
  IconsManifest: () => IconsManifest
});
var init_esm = __esm({
  "../../node_modules/@react-icons/all-files/lib/esm/index.js"() {
    "use strict";
    init_iconsManifest();
    init_iconBase();
    init_iconContext();
  }
});

// ../../node_modules/@react-icons/all-files/si/SiFacebook.js
var require_SiFacebook = __commonJS({
  "../../node_modules/@react-icons/all-files/si/SiFacebook.js"(exports, module) {
    "use strict";
    var GenIcon2 = (init_esm(), __toCommonJS(esm_exports)).GenIcon;
    module.exports.SiFacebook = function SiFacebook2(props) {
      return GenIcon2({ "tag": "svg", "attr": { "role": "img", "viewBox": "0 0 24 24" }, "child": [{ "tag": "title", "attr": {}, "child": [] }, { "tag": "path", "attr": { "d": "M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z" } }] })(props);
    };
  }
});

// ../../node_modules/@react-icons/all-files/si/SiLinkedin.js
var require_SiLinkedin = __commonJS({
  "../../node_modules/@react-icons/all-files/si/SiLinkedin.js"(exports, module) {
    "use strict";
    var GenIcon2 = (init_esm(), __toCommonJS(esm_exports)).GenIcon;
    module.exports.SiLinkedin = function SiLinkedin2(props) {
      return GenIcon2({ "tag": "svg", "attr": { "role": "img", "viewBox": "0 0 24 24" }, "child": [{ "tag": "title", "attr": {}, "child": [] }, { "tag": "path", "attr": { "d": "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" } }] })(props);
    };
  }
});

// ../../node_modules/@react-icons/all-files/si/SiInstagram.js
var require_SiInstagram = __commonJS({
  "../../node_modules/@react-icons/all-files/si/SiInstagram.js"(exports, module) {
    "use strict";
    var GenIcon2 = (init_esm(), __toCommonJS(esm_exports)).GenIcon;
    module.exports.SiInstagram = function SiInstagram2(props) {
      return GenIcon2({ "tag": "svg", "attr": { "role": "img", "viewBox": "0 0 24 24" }, "child": [{ "tag": "title", "attr": {}, "child": [] }, { "tag": "path", "attr": { "d": "M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" } }] })(props);
    };
  }
});

// src/AppEmployerRoutes.tsx
import { Navigate as Navigate13 } from "react-router-dom";
import { ErrorContainer as ErrorContainer2 } from "shared-ui";
import { DebuggerConfig } from "app-core";

// src/components/error/ErrorPage.tsx
import { useRouteError } from "react-router-dom";
import { jsx, jsxs } from "react/jsx-runtime";
var ErrorPage = (props) => {
  const error = useRouteError();
  return /* @__PURE__ */ jsxs("div", { className: "m-8", children: [
    /* @__PURE__ */ jsx("div", { className: "py-4", children: /* @__PURE__ */ jsx("p", { children: "An error has occurred" }) }),
    /* @__PURE__ */ jsx("div", { className: "border bg-yellow-50", children: /* @__PURE__ */ jsx("pre", { children: JSON.stringify(error) }) })
  ] });
};

// src/components/sign-in/SignInLoader.tsx
import { MynLogo } from "app-core";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCustomEventListener,
  useClearNextLocation,
  useNextLocation
} from "shared-lib";
import { Button, Size } from "shared-ui";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var SignInLoader = () => {
  const navigate = useNavigate();
  const clearLocation = useClearNextLocation();
  const [nextLocation] = useNextLocation();
  const [nextPage, setNextPage] = useState(null);
  useEffect(() => {
    if (!nextPage) {
      return;
    }
    if (nextPage.startsWith("http")) {
      window.location.href = nextPage;
    } else {
      navigate(nextPage, { replace: true });
    }
  }, [navigate, nextPage]);
  useCustomEventListener(
    "user-signed-in",
    () => {
      if (nextLocation) {
        setNextPage(nextLocation);
        clearLocation();
      } else {
        setNextPage("../app");
      }
    },
    [nextLocation]
  );
  return /* @__PURE__ */ jsx2("div", { className: "container mx-auto flex h-full h-screen justify-center", children: /* @__PURE__ */ jsx2("div", { className: "flex h-full max-w-lg flex-grow items-center bg-white", children: /* @__PURE__ */ jsxs2("div", { className: "flex h-fit flex-grow flex-col justify-center rounded border bg-white p-10 p-4 text-center", children: [
    /* @__PURE__ */ jsx2("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx2("div", { className: "flex w-full items-center space-x-4", children: /* @__PURE__ */ jsx2("div", { className: "mx-auto flex items-center justify-center py-2", children: /* @__PURE__ */ jsx2(MynLogo, { size: Size.lg }) }) }) }),
    /* @__PURE__ */ jsx2("div", { className: "flex w-full flex-col gap-2", children: /* @__PURE__ */ jsxs2("div", { children: [
      /* @__PURE__ */ jsx2("h2", { className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: /* @__PURE__ */ jsx2("span", { className: "block", children: "Employers" }) }),
      /* @__PURE__ */ jsx2("div", { className: "pt-4", children: /* @__PURE__ */ jsx2("div", { className: "text-md text-primary-500 font-medium", children: "Start changing your work life today" }) }),
      /* @__PURE__ */ jsx2("div", { className: "mt-8 flex justify-center", children: /* @__PURE__ */ jsx2("div", { className: "flex gap-2", children: /* @__PURE__ */ jsx2(
        Button,
        {
          color: "primary",
          onClick: () => navigate("../app"),
          size: Size.xl,
          children: /* @__PURE__ */ jsx2("div", { className: "mx-1 flex items-center gap-1", children: /* @__PURE__ */ jsx2("div", { className: "whitespace-nowrap text-sm", children: "Go to Portal" }) })
        }
      ) }) })
    ] }) })
  ] }) }) });
};

// src/components/chatwoot/index.tsx
import { useEffect as useEffect2 } from "react";
function useChatwoot() {
  useEffect2(() => {
    (function(d, t) {
      if (document.querySelector("#chatwoot") === null) {
        const BASE_URL = "https://app.chatwoot.com";
        const g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
        g.id = "chatwoot";
        g.src = BASE_URL + "/packs/js/sdk.js";
        g.defer = true;
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          window.chatwootSDK.run({
            websiteToken: "DPrF8aTVhDSr42Hi8EcEbwvv",
            baseUrl: BASE_URL
          });
        };
      }
    })(document, "script");
    const interval = setInterval(() => {
      const chatwoot = document.querySelector(
        ".woot-widget-bubble.woot-elements--right"
      );
      if (chatwoot && chatwoot.getAttribute("title") !== "chat with Myn support") {
        chatwoot.setAttribute("title", "chat with Myn support");
        clearInterval(interval);
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);
}

// src/public/AppEmployersPublicLayout.tsx
import { useRouteError as useRouteError2, Outlet } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { AuthError, LogLevel, useLogger } from "shared-lib";
import { ErrorBoundaryFallback } from "app-core";

// src/public/Signup.tsx
var import_SiFacebook = __toESM(require_SiFacebook());
var import_SiLinkedin = __toESM(require_SiLinkedin());
var import_SiInstagram = __toESM(require_SiInstagram());
import { RiTwitterXLine } from "react-icons/ri";
import { EdLink } from "shared-ui";
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var Signup = () => {
  return /* @__PURE__ */ jsx3("div", { className: "container mx-auto", children: /* @__PURE__ */ jsxs3("div", { className: "flex flex-col items-center gap-10 p-10", children: [
    /* @__PURE__ */ jsxs3("div", { className: "text-center", children: [
      /* @__PURE__ */ jsx3("h1", { className: "text-3xl font-bold tracking-tighter", children: "\u{1F6E0}\uFE0F Under Construction \u2013 Coming Soon!" }),
      /* @__PURE__ */ jsx3("h2", { className: "text-2xl", children: "Welcome to the Future of Hiring! \u{1F680}" })
    ] }),
    /* @__PURE__ */ jsxs3("div", { className: "prose", children: [
      /* @__PURE__ */ jsx3("h3", { className: "pb-2 text-xl", children: "We're Thrilled You're Here!" }),
      /* @__PURE__ */ jsx3("p", { children: "Get ready to embark on a hiring journey like never before! Myn is cooking up something extraordinary, and we cant wait to share it with you." }),
      /* @__PURE__ */ jsx3("h3", { className: "pb-2 text-xl", children: "\u{1F31F} What's in Store for You?" }),
      /* @__PURE__ */ jsxs3("ul", { className: "list-style-check list-outside", children: [
        /* @__PURE__ */ jsx3("li", { children: "Seamless Vacancy Management: Our new portal is designed with you in mind. Effortlessly add, manage, and track your job vacancies from one centralized hub." }),
        /* @__PURE__ */ jsx3("li", { children: "Intuitive User Interface: Say goodbye to complexity! Our user-friendly interface ensures a smooth experience, even for those new to the hiring game." }),
        /* @__PURE__ */ jsx3("li", { children: "Smart Recruitment Tools: Leverage cutting-edge tools powered by AI to find the perfect match for your team. Myn is not just a platform; it's your hiring sidekick!" }),
        /* @__PURE__ */ jsx3("li", { children: "Real-time Updates: Stay in the loop with instant updates on your job postings. Know when your dream candidate applies and make your hiring decisions faster than ever." })
      ] }),
      /* @__PURE__ */ jsx3("h3", { className: "pb-2 text-xl", children: "\u{1F680} How Can You Join the Revolution?" }),
      /* @__PURE__ */ jsx3("p", { children: "We're putting the finishing touches on our portal, and soon you'll be able to dive into a world of seamless, efficient, and exciting hiring." }),
      /* @__PURE__ */ jsxs3("div", { className: "flex flex-col gap-5 pb-8", children: [
        /* @__PURE__ */ jsx3(FakeBullet, { icon: /* @__PURE__ */ jsx3(Fragment, { children: "\u{1F514}" }), children: /* @__PURE__ */ jsx3(Fragment, { children: "Sign Up for Early Access: Be among the first to experience the future of hiring. Sign up now, and we'll notify you the moment the doors swing open!" }) }),
        /* @__PURE__ */ jsx3(FakeBullet, { icon: /* @__PURE__ */ jsx3(Fragment, { children: "\u{1F381}" }), children: /* @__PURE__ */ jsx3(Fragment, { children: "Exclusive Sneak Peeks: Our early birds get more than just the worm \u2013 they get exclusive sneak peeks and insights into the powerful features awaiting them." }) }),
        /* @__PURE__ */ jsx3(FakeBullet, { icon: /* @__PURE__ */ jsx3(Fragment, { children: "\u{1F6A7}" }), children: /* @__PURE__ */ jsx3(Fragment, { children: "Stay Tuned \u2013 Something Amazing is Taking Shape!" }) })
      ] }),
      /* @__PURE__ */ jsx3("p", { children: "The Myn team is buzzing with excitement, and we can't wait to welcome you to a hiring revolution. The construction crew is working hard to ensure every detail exceeds your expectations." }),
      /* @__PURE__ */ jsx3("p", { children: "Follow Us on Social Media: Catch behind-the-scenes action, updates, and more on our social media channels. Be part of the conversation and share the excitement!" }),
      "Get ready to redefine your hiring experience. The future is bright, and at Myn, it's also friendly, efficient, and downright exciting!"
    ] }),
    /* @__PURE__ */ jsx3("p", { children: "See you on the other side of innovation!" }),
    /* @__PURE__ */ jsxs3("p", { children: [
      "The ",
      /* @__PURE__ */ jsx3("span", { className: "font-bold text-black", children: "Myn Team \u{1F680}" })
    ] }),
    /* @__PURE__ */ jsxs3("div", { className: "flex gap-5 text-gray-500 ", children: [
      /* @__PURE__ */ jsx3(
        EdLink,
        {
          href: "https://www.linkedin.com/company/myn-co-uk/",
          name: "linkedin",
          children: /* @__PURE__ */ jsx3("div", { className: "p-5 hover:text-gray-900 ", children: /* @__PURE__ */ jsx3(import_SiLinkedin.SiLinkedin, { className: "" }) })
        }
      ),
      /* @__PURE__ */ jsx3(EdLink, { href: "https://twitter.com/myn_co_uk", name: "x", children: /* @__PURE__ */ jsx3("div", { className: "p-5 hover:text-gray-900 ", children: /* @__PURE__ */ jsx3(RiTwitterXLine, { className: "" }) }) }),
      /* @__PURE__ */ jsx3(EdLink, { href: "https://www.facebook.com/myn.co.uk", name: "fb", children: /* @__PURE__ */ jsx3("div", { className: "p-5 hover:text-gray-900 ", children: /* @__PURE__ */ jsx3(import_SiFacebook.SiFacebook, { className: "" }) }) }),
      /* @__PURE__ */ jsx3(EdLink, { href: "https://www.instagram.com/myn.co.uk/", name: "instagram", children: /* @__PURE__ */ jsx3("div", { className: "p-5 hover:text-gray-900 ", children: /* @__PURE__ */ jsx3(import_SiInstagram.SiInstagram, { className: "" }) }) })
    ] })
  ] }) });
};
var FakeBullet = ({
  icon,
  children
}) => {
  return /* @__PURE__ */ jsxs3("div", { className: "flex items-center gap-5", children: [
    /* @__PURE__ */ jsx3("div", { children: /* @__PURE__ */ jsx3("div", { className: "flex h-8 w-8 grow items-center justify-center rounded-full bg-gray-200", children: icon }) }),
    /* @__PURE__ */ jsx3("div", { className: "flex shrink leading-6", children })
  ] });
};

// src/public/AppEmployersPublicLayout.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
function ErrorPage2() {
  const error = useRouteError2();
  const [log] = useLogger();
  log(error, LogLevel.ERROR);
  if (AuthError.isAuthError(error)) {
    return /* @__PURE__ */ jsxs4("div", { children: [
      /* @__PURE__ */ jsx4("p", { children: "Authentication Error" }),
      /* @__PURE__ */ jsx4("pre", { children: JSON.stringify(error) })
    ] });
  }
  return /* @__PURE__ */ jsxs4("div", { children: [
    /* @__PURE__ */ jsx4("p", { children: "Application Error" }),
    /* @__PURE__ */ jsx4("pre", { children: JSON.stringify(error) })
  ] });
}
var AppEmployersPublicRoutes = [
  {
    path: "*",
    element: /* @__PURE__ */ jsx4(Outlet, {}),
    children: [
      {
        path: "signup/*",
        element: /* @__PURE__ */ jsx4(Signup, {})
      }
    ],
    errorElement: /* @__PURE__ */ jsx4(ErrorPage2, {})
  }
];
var AppEmployersPublicLayout = () => {
  return /* @__PURE__ */ jsx4(ErrorBoundary, { FallbackComponent: ErrorBoundaryFallback, children: /* @__PURE__ */ jsx4(Outlet, {}) });
};

// src/secure/account/AccountLayout.tsx
import { Suspense as Suspense2 } from "react";
import { ErrorBoundary as ErrorBoundary2 } from "react-error-boundary";
import {
  ArrowLeftOnRectangleIcon,
  UserCircleIcon,
  LockClosedIcon,
  PhoneIcon,
  CalendarDaysIcon
} from "@heroicons/react/24/outline";
import { EdSkeleton as EdSkeleton2, SectionedLayout } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback2 } from "app-core";
import { AvailabilityCalendar } from "feature-recruit";

// src/secure/account/pages/SignoutPage.tsx
import { useCallback } from "react";
import { Button as Button2 } from "shared-ui";
import { useAuth } from "app-core";
import { jsx as jsx5 } from "react/jsx-runtime";
var SignOutPage = () => {
  const auth = useAuth();
  const onSignOut = useCallback(async () => {
    await auth?.signOutRedirect();
  }, [auth]);
  return /* @__PURE__ */ jsx5(Button2, { color: "danger", onClick: onSignOut, children: "Sign out" });
};

// src/secure/account/pages/__generated__/SwitchAccountPageQuery.graphql.ts
var node = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": "accounts",
      "args": null,
      "concreteType": "EmployerUserSession",
      "kind": "LinkedField",
      "name": "accountsEmployerUserEmployerAccounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userFirstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userLastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userEmailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "SwitchAccountPageQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "SwitchAccountPageQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "17b5e0c7543be283b70eabde41311489",
      "id": null,
      "metadata": {},
      "name": "SwitchAccountPageQuery",
      "operationKind": "query",
      "text": "query SwitchAccountPageQuery {\n  accounts: accountsEmployerUserEmployerAccounts {\n    __typename\n    id\n    isCurrent\n    userFirstName\n    userLastName\n    userEmailAddress\n    employerId\n    employerName\n  }\n}\n"
    }
  };
}();
node.hash = "ece92418153a4d0b2a4ba90e0d3e2416";
var SwitchAccountPageQuery_graphql_default = node;

// src/secure/account/pages/SwitchAccountPage.tsx
import { useCallback as useCallback2, useEffect as useEffect3, useTransition } from "react";
import {
  usePreloadedQuery,
  useQueryLoader
} from "react-relay";
import { Suspense } from "shared-ui";
import { createClientMutationId } from "shared-lib";
import { Button as Button3, EdSkeleton, Loading } from "shared-ui";
import { useManageUserSessionContext } from "app-core";

// src/secure/account/mutations/__generated__/UseEmployerUserSetEmployerSessionMutation.graphql.ts
var node2 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EmployerUserSession",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCurrent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userFirstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userLastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userEmailAddress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserSetEmployerSessionMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "AccountsEmployerUserSetEmployerSessionPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserSetEmployerSession",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserSetEmployerSessionMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "AccountsEmployerUserSetEmployerSessionPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserSetEmployerSession",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v2,
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6d89ef8ff6b97516b3462ad32640a481",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserSetEmployerSessionMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserSetEmployerSessionMutation(\n  $input: AccountsEmployerUserSetEmployerSessionInput!\n) {\n  result: accountsEmployerUserSetEmployerSession(input: $input) {\n    payload {\n      __typename\n      id\n      isCurrent\n      userFirstName\n      userLastName\n      userEmailAddress\n      employerId\n      employerName\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node2.hash = "9934bf7043a89befa0691ddd522df10b";
var UseEmployerUserSetEmployerSessionMutation_graphql_default = node2;

// src/secure/account/mutations/UseEmployerUserSetEmployerSession.ts
import { useAsyncMutation } from "shared-lib";
var mutationDef = UseEmployerUserSetEmployerSessionMutation_graphql_default;
function useEmployerUserSetEmployerSession() {
  const [commit, isBusy] = useAsyncMutation(mutationDef);
  return [commit, isBusy];
}

// src/secure/account/pages/SwitchAccountPage.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var queryDef = SwitchAccountPageQuery_graphql_default;
var EmployerUserSessionItem = ({ account, onReload }) => {
  const [setSession, isSettingSession] = useEmployerUserSetEmployerSession();
  const onSetSession = useCallback2(async () => {
    const input = {
      employerId: account.employerId,
      clientMutationId: createClientMutationId()
    };
    const response = await setSession({ input });
    if (response.result.payload) {
      onReload();
    }
  }, [onReload, setSession]);
  return /* @__PURE__ */ jsxs5("div", { className: "flex flex-col p-4", children: [
    /* @__PURE__ */ jsxs5("div", { className: "flex items-center justify-between border bg-gray-100 p-2", children: [
      /* @__PURE__ */ jsx6("div", { className: "text-primary-800 p-2", children: account.employerName }),
      /* @__PURE__ */ jsx6("div", { children: account.isCurrent ? /* @__PURE__ */ jsx6("div", { className: "text-primary-800 font-bold", children: "Current" }) : /* @__PURE__ */ jsx6(
        Button3,
        {
          "aria-label": "switch account",
          color: "primary",
          clicked: onSetSession,
          disabled: isSettingSession,
          children: "Switch"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-1 p-2 text-gray-800", children: [
        /* @__PURE__ */ jsx6("div", { children: account.userFirstName }),
        /* @__PURE__ */ jsx6("div", { children: account.userLastName })
      ] }),
      /* @__PURE__ */ jsx6("div", { className: "text-gray-500", children: account.userEmailAddress })
    ] })
  ] });
};
var SwitchAccountList = ({ queryRef, onReload }) => {
  const data = usePreloadedQuery(queryDef, queryRef);
  const { accounts } = data;
  const accountsList = accounts.map((a) => {
    return /* @__PURE__ */ jsx6(EmployerUserSessionItem, { account: a, onReload }, a.id);
  });
  return /* @__PURE__ */ jsx6("div", { className: "border bg-white p-4 md:container", children: /* @__PURE__ */ jsx6("div", { className: "flex flex-col gap-2", children: accountsList }) });
};
var SwitchAccountPage = () => {
  const { session, forceSession } = useManageUserSessionContext();
  const [isLoading, startTransition] = useTransition();
  const [queryReference, loadQuery4] = useQueryLoader(queryDef);
  useEffect3(() => {
    loadQuery4({}, { fetchPolicy: "network-only" });
  }, []);
  const reload = useCallback2(() => {
    startTransition(() => {
      loadQuery4({}, { fetchPolicy: "network-only" });
      forceSession();
    });
  }, [startTransition, loadQuery4]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx6(EdSkeleton, {});
  }
  return /* @__PURE__ */ jsxs5(Suspense, { fallback: /* @__PURE__ */ jsx6(Loading, {}), children: [
    /* @__PURE__ */ jsx6("div", { className: "my-4 border bg-white p-4 font-medium", children: session?.employerName }),
    /* @__PURE__ */ jsx6(SwitchAccountList, { queryRef: queryReference, onReload: reload })
  ] });
};

// src/secure/account/pages/__generated__/ContactDetailsPageQuery.graphql.ts
var node3 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "ContactDetailsPageQuery",
      "selections": [
        {
          "alias": "account",
          "args": null,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserViewer",
          "plural": false,
          "selections": [
            v0,
            v1,
            v2,
            v3,
            v4,
            v5,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserDetailsEditor_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserEmailEditor_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserPasswordEditor_user"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "ContactDetailsPageQuery",
      "selections": [
        {
          "alias": "account",
          "args": null,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserViewer",
          "plural": false,
          "selections": [
            v0,
            v1,
            v2,
            v3,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDeleted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployerUserGroup",
              "kind": "LinkedField",
              "name": "userGroups",
              "plural": true,
              "selections": [
                v1,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAdminGroup",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDefault",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c3e02dc547f5438275535ffbc8591f1a",
      "id": null,
      "metadata": {},
      "name": "ContactDetailsPageQuery",
      "operationKind": "query",
      "text": "query ContactDetailsPageQuery {\n  account: accountEmployerUserViewer {\n    __typename\n    id\n    accountId\n    firstName\n    lastName\n    emailAddress\n    ...EmployerUserDetailsEditor_user\n    ...EmployerUserEmailEditor_user\n    ...EmployerUserPasswordEditor_user\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n\nfragment EmployerUserEmailEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  emailAddress\n  updatedAt\n  createdAt\n}\n\nfragment EmployerUserPasswordEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  emailAddress\n  updatedAt\n  createdAt\n}\n"
    }
  };
}();
node3.hash = "0fa4c666587fe945e8f1aa2420f49d5a";
var ContactDetailsPageQuery_graphql_default = node3;

// src/secure/account/pages/ContactDetailsPage.tsx
import { useState as useState2 } from "react";
import { useLazyLoadQuery } from "react-relay";
import { Button as Button4 } from "shared-ui";
import {
  EmployerUserDetailsEditor,
  EmployerUserEmailEditor,
  EmployerUserPasswordEditor
} from "feature-employer-accounts";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var queryDef2 = ContactDetailsPageQuery_graphql_default;
var ContactDetailsPage = () => {
  const [uiState, setUIState] = useState2(0 /* View */);
  const data = useLazyLoadQuery(
    queryDef2,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { account } = data;
  if (!account) {
    return /* @__PURE__ */ jsx7("div", { children: "No Account Data Found, Please Wait...." });
  }
  let content = /* @__PURE__ */ jsx7("div", {});
  switch (uiState) {
    case 0 /* View */: {
      content = /* @__PURE__ */ jsx7("div", { className: "mt-6 border border-gray-200", children: /* @__PURE__ */ jsxs6("dl", { className: "divide-y divide-gray-100", children: [
        /* @__PURE__ */ jsxs6("div", { className: "bg-gray-50 px-4 py-6 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-3", children: [
          /* @__PURE__ */ jsx7("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Name" }),
          /* @__PURE__ */ jsxs6("dd", { className: "mt-1 flex items-center gap-2 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: [
            /* @__PURE__ */ jsx7("span", { children: account.firstName }),
            /* @__PURE__ */ jsx7("span", { children: account.lastName })
          ] }),
          /* @__PURE__ */ jsx7("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:mt-0", children: /* @__PURE__ */ jsx7(
            Button4,
            {
              "aria-label": "edit contact name",
              color: "primary",
              clicked: () => setUIState(1 /* EditDetails */),
              children: "Edit"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs6("div", { className: "bg-white px-4 py-6 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-3", children: [
          /* @__PURE__ */ jsx7("dt", { className: "text-sm font-medium leading-6 text-gray-900", children: "Email" }),
          /* @__PURE__ */ jsx7("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: account.emailAddress }),
          /* @__PURE__ */ jsx7("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:mt-0", children: /* @__PURE__ */ jsx7(
            Button4,
            {
              "aria-label": "edit contact email",
              color: "primary",
              clicked: () => setUIState(2 /* EditEmail */),
              children: "Edit"
            }
          ) })
        ] })
      ] }) });
      break;
    }
    case 1 /* EditDetails */: {
      content = /* @__PURE__ */ jsx7("div", { className: "mt-6 border border-gray-100", children: /* @__PURE__ */ jsx7(
        EmployerUserDetailsEditor,
        {
          fragmentRef: account,
          onDone: () => setUIState(0 /* View */),
          onEnabled: () => setUIState(0 /* View */),
          onDisabled: () => setUIState(0 /* View */),
          onCancel: () => setUIState(0 /* View */)
        }
      ) });
      break;
    }
    case 2 /* EditEmail */: {
      content = /* @__PURE__ */ jsx7("div", { className: "mt-6 border border-gray-100", children: /* @__PURE__ */ jsx7(
        EmployerUserEmailEditor,
        {
          fragmentRef: account,
          onDone: () => setUIState(0 /* View */),
          onCancel: () => setUIState(0 /* View */)
        }
      ) });
      break;
    }
    case 3 /* EditPassword */: {
      content = /* @__PURE__ */ jsx7("div", { className: "mt-6 border border-gray-100", children: /* @__PURE__ */ jsx7(
        EmployerUserPasswordEditor,
        {
          fragmentRef: account,
          onDone: () => setUIState(0 /* View */),
          onCancel: () => setUIState(0 /* View */)
        }
      ) });
      break;
    }
  }
  return /* @__PURE__ */ jsx7("div", { className: "flex flex-col gap-2 p-4 md:w-2/3", children: content });
};

// src/secure/account/pages/SecurityPage.tsx
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useIdentityLink } from "app-core";
import { Button as Button5, Card, EdLink as EdLink2 } from "shared-ui";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var SecurityPage = () => {
  const accountLink = useIdentityLink();
  return /* @__PURE__ */ jsx8("div", { className: "m-4 flex flex-col items-center justify-center", children: /* @__PURE__ */ jsxs7(Card, { children: [
    /* @__PURE__ */ jsx8("div", { className: "border-b p-4", children: /* @__PURE__ */ jsx8("h1", { className: "text-2xl", children: "Forgot your password?" }) }),
    /* @__PURE__ */ jsxs7("div", { className: "flex flex-col gap-5 p-4", children: [
      /* @__PURE__ */ jsx8("p", { children: "Click the button below to proceed to the password reset page." }),
      /* @__PURE__ */ jsx8(EdLink2, { name: "reset-password", href: `${accountLink}/forgot-password`, children: /* @__PURE__ */ jsxs7(
        Button5,
        {
          "aria-label": "Reset Password",
          className: "w-full rounded-none px-4 py-2 font-bold uppercase",
          color: "primary",
          children: [
            "Reset Password ",
            /* @__PURE__ */ jsx8(ChevronRightIcon, { className: "h-5 w-5 text-white" })
          ]
        }
      ) })
    ] })
  ] }) });
};

// src/secure/account/AccountLayout.tsx
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var AccountLoading = () => {
  return /* @__PURE__ */ jsxs8("div", { className: "m-8", children: [
    /* @__PURE__ */ jsx9("div", { className: "p-4", children: "Loading Account...." }),
    /* @__PURE__ */ jsx9(EdSkeleton2, {})
  ] });
};
var SectionElement = ({ children }) => {
  return /* @__PURE__ */ jsx9("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var AccountLayout = () => {
  const sections = [
    {
      key: "contact-details",
      itemTitle: "Contact Details",
      listTitle: "Contact Details",
      icon: PhoneIcon,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      element: /* @__PURE__ */ jsx9(Suspense2, { fallback: /* @__PURE__ */ jsx9(AccountLoading, {}), children: /* @__PURE__ */ jsx9(SectionElement, { children: /* @__PURE__ */ jsx9(ContactDetailsPage, {}) }) })
    },
    {
      key: "security",
      itemTitle: "Password and Security",
      listTitle: "Password and Security",
      icon: LockClosedIcon,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      element: /* @__PURE__ */ jsx9(Suspense2, { fallback: /* @__PURE__ */ jsx9(AccountLoading, {}), children: /* @__PURE__ */ jsx9(SectionElement, { children: /* @__PURE__ */ jsx9(SecurityPage, {}) }) })
    },
    {
      key: "switch",
      itemTitle: "Switch Account",
      listTitle: "Switch Account",
      icon: UserCircleIcon,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      element: /* @__PURE__ */ jsx9(Suspense2, { fallback: /* @__PURE__ */ jsx9(AccountLoading, {}), children: /* @__PURE__ */ jsx9(SectionElement, { children: /* @__PURE__ */ jsx9(SwitchAccountPage, {}) }) })
    },
    {
      key: "calendar",
      itemTitle: "Calendar",
      listTitle: "Calendar",
      icon: CalendarDaysIcon,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      element: /* @__PURE__ */ jsx9(Suspense2, { fallback: /* @__PURE__ */ jsx9(AccountLoading, {}), children: /* @__PURE__ */ jsx9(SectionElement, { children: /* @__PURE__ */ jsx9(AvailabilityCalendar, {}) }) })
    },
    {
      key: "logout",
      itemTitle: "Log out",
      listTitle: "Log out",
      icon: ArrowLeftOnRectangleIcon,
      iconForeground: "text-red-700",
      iconBackground: "bg-red-50",
      element: /* @__PURE__ */ jsx9(Suspense2, { fallback: /* @__PURE__ */ jsx9(AccountLoading, {}), children: /* @__PURE__ */ jsx9(SectionElement, { children: /* @__PURE__ */ jsx9(SignOutPage, {}) }) })
    }
  ];
  return /* @__PURE__ */ jsx9(Suspense2, { fallback: /* @__PURE__ */ jsx9(EdSkeleton2, {}), children: /* @__PURE__ */ jsx9(ErrorBoundary2, { FallbackComponent: ErrorBoundaryFallback2, children: /* @__PURE__ */ jsx9(SectionedLayout, { title: "Account", sections }) }) });
};
var AccountLayout_default = AccountLayout;

// src/secure/account/__generated__/AccountPageQuery.graphql.ts
var node4 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": "account",
      "args": null,
      "concreteType": "AccountsEmployerUser",
      "kind": "LinkedField",
      "name": "accountEmployerUserViewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "AccountPageQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "AccountPageQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "1e21e70749002e0d07355278364ae29e",
      "id": null,
      "metadata": {},
      "name": "AccountPageQuery",
      "operationKind": "query",
      "text": "query AccountPageQuery {\n  account: accountEmployerUserViewer {\n    id\n    accountId\n    firstName\n    lastName\n  }\n}\n"
    }
  };
}();
node4.hash = "1eee29954daf2a1b4dc86cfbbb335a66";
var AccountPageQuery_graphql_default = node4;

// src/secure/account/AccountPage.tsx
import { useLazyLoadQuery as useLazyLoadQuery2 } from "react-relay";
import { jsx as jsx10 } from "react/jsx-runtime";
var queryDef3 = AccountPageQuery_graphql_default;
var AccountPage = () => {
  const data = useLazyLoadQuery2(
    queryDef3,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { account } = data;
  if (!account) {
    return /* @__PURE__ */ jsx10("div", { children: "No Account Data Found, Please Wait...." });
  }
  return /* @__PURE__ */ jsx10(AccountLayout_default, {});
};
var createAccountRoutes = (environment, context) => {
  return [];
};

// src/secure/accounts/AccountsLayout.tsx
import { Suspense as Suspense3 } from "react";
import { ErrorBoundary as ErrorBoundary3 } from "react-error-boundary";
import { BriefcaseIcon, UsersIcon } from "@heroicons/react/24/outline";
import { EdSkeleton as EdSkeleton3, SectionedLayout as SectionedLayout2 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback3 } from "app-core";
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var AccountLoading2 = () => {
  return /* @__PURE__ */ jsxs9("div", { className: "m-8", children: [
    /* @__PURE__ */ jsx11("div", { className: "p-4", children: "Loading Account...." }),
    /* @__PURE__ */ jsx11(EdSkeleton3, {})
  ] });
};
var SectionElement2 = ({ children }) => {
  return /* @__PURE__ */ jsx11("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var AccountsLayout = () => {
  const sections = [
    {
      key: "users",
      itemTitle: "Users",
      listTitle: "Users",
      icon: UsersIcon,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      element: /* @__PURE__ */ jsx11(Suspense3, { fallback: /* @__PURE__ */ jsx11(AccountLoading2, {}), children: /* @__PURE__ */ jsx11(SectionElement2, { children: /* @__PURE__ */ jsx11("div", { children: "Users" }) }) })
    },
    {
      key: "userGroups",
      itemTitle: "User Groups",
      listTitle: "User Groups",
      icon: BriefcaseIcon,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      element: /* @__PURE__ */ jsx11(Suspense3, { fallback: /* @__PURE__ */ jsx11(AccountLoading2, {}), children: /* @__PURE__ */ jsx11(SectionElement2, { children: /* @__PURE__ */ jsx11("div", { children: "User Groups" }) }) })
    }
  ];
  return /* @__PURE__ */ jsx11(Suspense3, { fallback: /* @__PURE__ */ jsx11(EdSkeleton3, {}), children: /* @__PURE__ */ jsx11(ErrorBoundary3, { FallbackComponent: ErrorBoundaryFallback3, children: /* @__PURE__ */ jsx11(SectionedLayout2, { title: "Accounts", sections }) }) });
};

// src/secure/vacancies/pages/VacancyCreatePage.tsx
import { Suspense as Suspense4 } from "react";
import { useSearchParams } from "react-router-dom";
import { useUserSessionContext } from "app-core";
import { VacancyCreateContainer } from "feature-recruit";
import { Breadcrumbs, DynamicBreadcrumb } from "shared-ui";
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var VacancyCreatePage = () => {
  const [searchParams] = useSearchParams();
  const session = useUserSessionContext();
  return /* @__PURE__ */ jsxs10("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx12(
      Suspense4,
      {
        fallback: /* @__PURE__ */ jsx12(
          Breadcrumbs,
          {
            links: [
              { name: "Vacancies", href: "../../../" },
              { name: "New Vacancy", href: "." }
            ]
          }
        ),
        children: /* @__PURE__ */ jsx12("div", { className: "md:border-b", children: /* @__PURE__ */ jsx12(DynamicBreadcrumb, {}) })
      }
    ),
    /* @__PURE__ */ jsx12("div", { className: "flex flex-col bg-white lg:pb-0", children: /* @__PURE__ */ jsx12("div", { className: "flex flex-col justify-between gap-2 px-4 py-2 lg:flex-row lg:gap-0", children: /* @__PURE__ */ jsx12("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx12("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ jsx12("div", { className: "py-2 text-2xl font-medium text-gray-700", children: "New Vacancy" }) }) }) }) }),
    /* @__PURE__ */ jsx12(
      VacancyCreateContainer,
      {
        employerId: session.employerId,
        projectId: searchParams.get("projectId"),
        projectName: searchParams.get("projectName")
      }
    )
  ] });
};

// src/secure/vacancies/VacanciesRoute.tsx
import { Navigate } from "react-router-dom";
import { BreadcrumbLink, EdSkeleton as EdSkeleton4, Suspense as Suspense5 } from "shared-ui";
import { OutletRoute } from "app-core";
import {
  ShowExpandVacancy,
  VacancyLink,
  VacancySearchLoader,
  createVacancyRoutes,
  vacancyLoader
} from "feature-recruit";
import { jsx as jsx13 } from "react/jsx-runtime";
var VacanciesListRoute = () => {
  return /* @__PURE__ */ jsx13(Suspense5, { fallback: /* @__PURE__ */ jsx13(EdSkeleton4, {}), children: /* @__PURE__ */ jsx13(VacancySearchLoader, {}) });
};
var createVacanciesRoutes = (environment, context) => {
  return [
    {
      path: "create/*",
      element: /* @__PURE__ */ jsx13(VacancyCreatePage, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx13(
          BreadcrumbLink,
          {
            to: "/employers/app/vacancies/create",
            label: "New Vacancy"
          }
        )
      }
    },
    {
      path: "list/*",
      element: /* @__PURE__ */ jsx13(VacanciesListRoute, {}),
      handle: {},
      children: [
        {
          id: "vacancies-route-list",
          path: ":vacancyCode/*",
          element: /* @__PURE__ */ jsx13(OutletRoute, {}),
          children: createVacancyRoutes(
            "vacancies-route-list",
            environment,
            context
          ),
          handle: {
            crumb: () => /* @__PURE__ */ jsx13(VacancyLink, { id: `vacancies-route-list` })
          },
          loader: ({ params }) => {
            return vacancyLoader(environment, params);
          }
        }
      ]
    },
    {
      id: "vacancies-route-view",
      path: "view/:vacancyCode/*",
      element: /* @__PURE__ */ jsx13(ShowExpandVacancy.Provider, { value: false, children: /* @__PURE__ */ jsx13(OutletRoute, {}) }),
      children: createVacancyRoutes("view", environment, context),
      handle: {
        crumb: () => /* @__PURE__ */ jsx13(VacancyLink, { id: `vacancies-route-view` })
      },
      loader: ({ params }) => {
        return vacancyLoader(environment, params);
      }
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx13(Navigate, { to: "list", replace: true })
    }
  ];
};

// src/secure/interviews/InterviewsRoute.tsx
import { Suspense as Suspense6 } from "react";
import { Outlet as Outlet2 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary4 } from "react-error-boundary";
import { EdSkeleton as EdSkeleton5 } from "shared-ui";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback4,
  useUserSessionContext as useUserSessionContext2
} from "app-core";
import { InterviewsContainer } from "feature-recruit";
import { jsx as jsx14 } from "react/jsx-runtime";
var InterviewsRoute = () => {
  return /* @__PURE__ */ jsx14(ErrorBoundary4, { FallbackComponent: ErrorBoundaryFallback4, children: /* @__PURE__ */ jsx14(Outlet2, {}) });
};
var InterviewsListRoute = () => {
  const session = useUserSessionContext2();
  return /* @__PURE__ */ jsx14(Suspense6, { fallback: /* @__PURE__ */ jsx14(EdSkeleton5, {}), children: /* @__PURE__ */ jsx14(InterviewsContainer, {}) });
};
var OfferRoute = () => {
  return /* @__PURE__ */ jsx14(Suspense6, { fallback: "Loading...", children: /* @__PURE__ */ jsx14(Outlet2, {}) });
};
var createInterviewsRoutes = (environment, context) => {
  return [
    {
      path: "list/*",
      element: /* @__PURE__ */ jsx14(InterviewsListRoute, {})
    }
  ];
};

// src/secure/__generated__/AppEmployersSecureLayoutQuery.graphql.ts
var node5 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountsEmployerUser",
      "kind": "LinkedField",
      "name": "accountEmployerUserViewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "AppEmployersSecureLayoutQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "AppEmployersSecureLayoutQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "844e2be50bee6156e1bd2eb98627b60d",
      "id": null,
      "metadata": {},
      "name": "AppEmployersSecureLayoutQuery",
      "operationKind": "query",
      "text": "query AppEmployersSecureLayoutQuery {\n  accountEmployerUserViewer {\n    id\n    accountId\n    firstName\n    lastName\n  }\n}\n"
    }
  };
}();
node5.hash = "08e5f5bfdb59a357f29d830f4d625809";
var AppEmployersSecureLayoutQuery_graphql_default = node5;

// src/secure/AppEmployersSecureLayout.tsx
import { createElement, useCallback as useCallback9, useEffect as useEffect4 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery4 } from "react-relay";
import {
  useLocation as useLocation3,
  Navigate as Navigate12,
  Outlet as Outlet11,
  Link as Link5
} from "react-router-dom";
import { ErrorBoundary as ErrorBoundary9 } from "react-error-boundary";
import { useSetAtom } from "jotai";
import {
  UserIcon as UserIcon2,
  ArrowRightOnRectangleIcon,
  UserCircleIcon as UserCircleIcon2,
  UserGroupIcon as UserGroupIcon3,
  UsersIcon as UsersIcon4,
  InboxStackIcon,
  ClipboardDocumentCheckIcon as ClipboardDocumentCheckIcon2,
  MagnifyingGlassIcon,
  Cog8ToothIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  BriefcaseIcon as BriefcaseIcon2,
  LightBulbIcon
} from "@heroicons/react/24/outline";
import {
  BreadcrumbLink as BreadcrumbLink3,
  createLinkState as createLinkState3,
  EdSkeleton as EdSkeleton21,
  Shell
} from "shared-ui";
import { RecruitConversationsChat } from "feature-chat";
import {
  useAuth as useAuth2,
  employerIdAtom,
  OutletRoute as OutletRoute7,
  useUserSessionContext as useUserSessionContext7
} from "app-core";
import { VacancyApplicationSearchFacetsContext } from "feature-recruit";

// src/secure/projects/ProjectsRoute.tsx
import { Navigate as Navigate2, Outlet as Outlet3 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary5 } from "react-error-boundary";
import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { EdSkeleton as EdSkeleton6, Suspense as Suspense7 } from "shared-ui";
import { useUserSessionContext as useUserSessionContext3 } from "app-core";
import {
  createProjectCreateRoute,
  createProjectRoutes,
  ProjectList
} from "feature-recruit";
import { jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var ProjectListRoute = () => {
  const session = useUserSessionContext3();
  return /* @__PURE__ */ jsx15(Suspense7, { fallback: /* @__PURE__ */ jsx15(EdSkeleton6, {}), children: /* @__PURE__ */ jsx15(ProjectList, { employerId: session.employerId }) });
};
var ProjectRoute = () => {
  return /* @__PURE__ */ jsx15("div", { className: "flex grow flex-col ", children: /* @__PURE__ */ jsx15(Suspense7, { fallback: "Loading...", children: /* @__PURE__ */ jsx15(Outlet3, {}) }) });
};
var createProjectsRoutes = (routePrefix, environment, context) => {
  const id = routePrefix + "-projects";
  return [
    {
      id,
      path: "list/*",
      element: /* @__PURE__ */ jsx15(ProjectListRoute, {}),
      handle: {},
      children: [
        {
          path: ":projectCode/*",
          element: /* @__PURE__ */ jsx15(
            ErrorBoundary5,
            {
              FallbackComponent: () => /* @__PURE__ */ jsx15("div", { className: "flex h-full w-full items-center justify-center", children: "Could not load this project" }),
              children: /* @__PURE__ */ jsx15(ProjectRoute, {})
            }
          ),
          children: createProjectRoutes("list", environment, context, true)
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsxs11("div", { className: "flex w-full flex-col items-center justify-center gap-3 py-8", children: [
            /* @__PURE__ */ jsx15(ClipboardDocumentCheckIcon, { className: "h-10 w-10" }),
            /* @__PURE__ */ jsxs11("div", { className: "flex flex-col text-center", children: [
              /* @__PURE__ */ jsx15("h1", { className: "text-2xl", children: "Projects" }),
              /* @__PURE__ */ jsx15("div", { children: "Select a project from the left or Create a new one now" })
            ] })
          ] })
        }
      ]
    },
    {
      path: ":projectCode/*",
      element: /* @__PURE__ */ jsx15(
        ErrorBoundary5,
        {
          FallbackComponent: () => /* @__PURE__ */ jsx15("div", { className: "flex h-full w-full items-center justify-center", children: "Could not find project" }),
          children: /* @__PURE__ */ jsx15(ProjectRoute, {})
        }
      ),
      children: createProjectRoutes("project", environment, context, false)
    },
    createProjectCreateRoute(id, environment, context),
    {
      path: "*",
      element: /* @__PURE__ */ jsx15(Navigate2, { to: "list", replace: true })
    }
  ];
};

// src/secure/applications/ApplicationsRoute.tsx
import { Suspense as Suspense8 } from "react";
import { Navigate as Navigate3, Outlet as Outlet4 } from "react-router-dom";
import { useUserSessionContext as useUserSessionContext4 } from "app-core";
import {
  createCandidateApplicationRoutes,
  CandidateApplicationSearchList,
  ShowExpandApplicationProfile
} from "feature-recruit";
import { jsx as jsx16 } from "react/jsx-runtime";
var ApplicationsListRoute = () => {
  const session = useUserSessionContext4();
  return /* @__PURE__ */ jsx16(CandidateApplicationSearchList, { employerId: session.employerId });
};
var ApplicationRoute = () => {
  return /* @__PURE__ */ jsx16(Suspense8, { fallback: "Loading...", children: /* @__PURE__ */ jsx16(Outlet4, {}) });
};
var createApplicationsRoutes = (environment, context) => {
  return [
    {
      path: "list/*",
      element: /* @__PURE__ */ jsx16(Suspense8, { children: /* @__PURE__ */ jsx16(ApplicationsListRoute, {}) }),
      children: [
        {
          path: ":applicationCode/*",
          element: /* @__PURE__ */ jsx16(ApplicationRoute, {}),
          children: createCandidateApplicationRoutes(
            "application-dashboard-application",
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx16("div", {})
        }
      ]
    },
    {
      path: "application/:applicationCode/*",
      element: /* @__PURE__ */ jsx16(ShowExpandApplicationProfile.Provider, { value: false, children: /* @__PURE__ */ jsx16(ApplicationRoute, {}) }),
      children: createCandidateApplicationRoutes(
        "application-dashboard-application-t",
        environment,
        context
      )
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx16(Navigate3, { to: "list", replace: true })
    }
  ];
};

// src/secure/settings/SettingsRoutes.tsx
import { Link, Outlet as Outlet5 } from "react-router-dom";
import { BreadcrumbLink as BreadcrumbLink2, ErrorContainer } from "shared-ui";
import {
  createEmployerVacancyTalentPoolDefaultInvitesEditorRoute,
  createProfileSourcesRoutes
} from "feature-recruit";
import { OutletRoute as OutletRoute2 } from "app-core";
import {
  createEmployerDetailsRoute,
  createEmployerLocationsRoute,
  createEmployersUsersRoutes,
  createEmployerUserGroupsRoutes
} from "feature-employer-accounts";

// src/secure/settings/SettingsLayout.tsx
import { Suspense as Suspense9 } from "react";
import {
  RectangleGroupIcon,
  UserGroupIcon,
  UserIcon,
  DocumentIcon,
  MapIcon
} from "@heroicons/react/24/outline";
import { EdSkeleton as EdSkeleton7, ListLayout } from "shared-ui";
import { jsx as jsx17 } from "react/jsx-runtime";
var links = [
  { key: "details", label: "Details", to: "details", icon: DocumentIcon },
  { key: "locations", label: "Locations", to: "locations", icon: MapIcon },
  { key: "users", label: "Users", to: "users", icon: UserIcon },
  {
    key: "user-groups",
    label: "User Groups",
    to: "user-groups",
    icon: UserGroupIcon
  },
  {
    key: "profile-sources",
    label: "Profile Sources",
    to: "profile-sources",
    icon: RectangleGroupIcon
  },
  {
    key: "talent-pool-invites",
    label: "Talent Pools",
    to: "talent-pool-invites",
    icon: RectangleGroupIcon
  }
];
var SettingsLayout = () => {
  return /* @__PURE__ */ jsx17(Suspense9, { fallback: /* @__PURE__ */ jsx17(EdSkeleton7, {}), children: /* @__PURE__ */ jsx17("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ jsx17("div", { className: "w-full min-w-0 flex-1 xl:flex", children: /* @__PURE__ */ jsx17(
    ListLayout,
    {
      title: "Employer Account Settings",
      sections: links.map((x) => ({
        key: x.key + "/list",
        listTitle: x.label,
        mobileLink: `../${x.key}/list`,
        itemTitle: x.label,
        element: /* @__PURE__ */ jsx17("div", {}),
        icon: x.icon
      }))
    }
  ) }) }) });
};

// src/secure/settings/SettingsHome.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var SettingsHome = () => {
  return /* @__PURE__ */ jsx18("div", { children: /* @__PURE__ */ jsx18("h1", { children: "Settings" }) });
};

// src/secure/settings/SettingsRoutes.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var settingsSuffix = "-employer-settings";
var settingRoutes = (routePrefix, environment, context) => [
  {
    path: "*",
    element: /* @__PURE__ */ jsx19(SettingsHome, {})
  },
  {
    path: "details/*",
    element: /* @__PURE__ */ jsx19(OutletRoute2, {}),
    children: createEmployerDetailsRoute(
      routePrefix + settingsSuffix,
      environment,
      context
    )
  },
  {
    path: "locations/*",
    element: /* @__PURE__ */ jsx19(OutletRoute2, {}),
    children: createEmployerLocationsRoute(
      routePrefix + settingsSuffix,
      environment,
      context
    )
  },
  {
    path: "profile-sources/*",
    element: /* @__PURE__ */ jsx19(OutletRoute2, {}),
    handle: {
      // you can put whatever you want on a route handle
      // here we use "crumb" and return some elements,
      // this is what we'll render in the breadcrumbs
      // for this route
      crumb: () => /* @__PURE__ */ jsx19(Link, { to: "/employers/app/settings/profile-sources", children: "Profile Sources" })
    },
    children: createProfileSourcesRoutes(
      routePrefix + settingsSuffix,
      environment,
      context
    )
  },
  {
    path: "users/*",
    element: /* @__PURE__ */ jsx19(OutletRoute2, {}),
    handle: {
      // you can put whatever you want on a route handle
      // here we use "crumb" and return some elements,
      // this is what we'll render in the breadcrumbs
      // for this route
      crumb: () => /* @__PURE__ */ jsx19(BreadcrumbLink2, { to: "/employers/app/settings/users/list", label: "Users" })
    },
    children: createEmployersUsersRoutes(
      routePrefix + settingsSuffix,
      environment,
      context
    )
  },
  {
    path: "user-groups/*",
    element: /* @__PURE__ */ jsx19(OutletRoute2, {}),
    handle: {
      // you can put whatever you want on a route handle
      // here we use "crumb" and return some elements,
      // this is what we'll render in the breadcrumbs
      // for this route
      crumb: () => /* @__PURE__ */ jsx19(
        BreadcrumbLink2,
        {
          to: "/employers/app/settings/user-groups/list",
          label: "Users"
        }
      )
    },
    children: createEmployerUserGroupsRoutes(
      routePrefix + settingsSuffix,
      environment,
      context
    )
  },
  {
    path: "talent-pool-invites/*",
    element: /* @__PURE__ */ jsx19(OutletRoute2, {}),
    handle: {
      // you can put whatever you want on a route handle
      // here we use "crumb" and return some elements,
      // this is what we'll render in the breadcrumbs
      // for this route
      crumb: () => /* @__PURE__ */ jsx19(
        BreadcrumbLink2,
        {
          to: "/employers/app/settings/talent-pool-invites/list",
          label: "Talent Pool Invite Defaults"
        }
      )
    },
    children: createEmployerVacancyTalentPoolDefaultInvitesEditorRoute(
      routePrefix + settingsSuffix,
      environment,
      context
    )
  }
];
var createSettingsRoutes = (environment, context) => {
  return [
    {
      path: "list/*",
      id: "employer-settings-list-root",
      element: /* @__PURE__ */ jsx19(SettingsLayout, {}),
      errorElement: /* @__PURE__ */ jsx19(ErrorContainer, {}),
      children: settingRoutes("list", environment, context)
    },
    {
      path: "*",
      id: "employer-settings-root",
      element: /* @__PURE__ */ jsx19(Outlet5, {}),
      errorElement: /* @__PURE__ */ jsx19(ErrorContainer, {}),
      children: settingRoutes("single", environment, context)
    }
  ];
};

// src/secure/offers/OffersRoute.tsx
import { Suspense as Suspense10 } from "react";
import { Navigate as Navigate4, Outlet as Outlet6 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary6 } from "react-error-boundary";
import { EdSkeleton as EdSkeleton8 } from "shared-ui";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback5,
  useUserSessionContext as useUserSessionContext5
} from "app-core";
import { createOfferRoutes, EmployersOfferSearchList } from "feature-recruit";
import { jsx as jsx20 } from "react/jsx-runtime";
var OffersListRoute = () => {
  const session = useUserSessionContext5();
  return /* @__PURE__ */ jsx20(Suspense10, { fallback: /* @__PURE__ */ jsx20(EdSkeleton8, {}), children: /* @__PURE__ */ jsx20(EmployersOfferSearchList, { employerId: session.employerId }) });
};
var OfferRoute2 = () => {
  return /* @__PURE__ */ jsx20(Suspense10, { fallback: "Loading...", children: /* @__PURE__ */ jsx20(Outlet6, {}) });
};
var createOffersRoutes = (environment, context) => {
  return [
    {
      path: "list/*",
      element: /* @__PURE__ */ jsx20(OffersListRoute, {}),
      children: [
        {
          path: ":offerCode/*",
          element: /* @__PURE__ */ jsx20(OfferRoute2, {}),
          children: createOfferRoutes(
            "offers-list-offer",
            environment,
            context,
            true
          )
        }
      ]
    },
    {
      path: ":offerCode/*",
      element: /* @__PURE__ */ jsx20(OfferRoute2, {}),
      children: createOfferRoutes("offers-offer", environment, context, true)
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx20(Navigate4, { to: "list", replace: true })
    }
  ];
};

// src/secure/profile-search/ProfileSearchRoute.tsx
import { Suspense as Suspense11 } from "react";
import { Outlet as Outlet7, Navigate as Navigate5 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary7 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback6 } from "app-core";
import {
  Profile,
  ProfileDetails,
  ProfileNotes,
  ProfileSearchContainer,
  ProfileWorkHistory,
  ProfileWorkTimeline
} from "feature-recruit";
import { jsx as jsx21 } from "react/jsx-runtime";
var createProfileSearchContainerRoutes = () => {
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx21(ProfileSearchContainer, {}),
      children: [
        {
          path: ":profileId/*",
          element: /* @__PURE__ */ jsx21(Suspense11, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(Profile, { isInList: true }) }),
          children: [
            {
              path: "*",
              element: /* @__PURE__ */ jsx21(Navigate5, { to: `top-skills`, replace: true })
            },
            {
              path: "top-skills",
              element: /* @__PURE__ */ jsx21(Suspense11, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(ProfileWorkTimeline, {}) })
            },
            {
              path: "work-history",
              element: /* @__PURE__ */ jsx21(Suspense11, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(ProfileWorkHistory, {}) })
            },
            {
              path: "details",
              element: /* @__PURE__ */ jsx21(Suspense11, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(ProfileDetails, {}) })
            },
            {
              path: "notes",
              element: /* @__PURE__ */ jsx21(Suspense11, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(ProfileNotes, {}) })
            }
          ]
        }
      ]
    },
    {
      path: "profile/:profileId",
      element: /* @__PURE__ */ jsx21(Suspense11, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(Profile, { isInList: false }) })
    }
  ];
};
var ProfileRoute = () => {
  return /* @__PURE__ */ jsx21(ErrorBoundary7, { FallbackComponent: ErrorBoundaryFallback6, children: /* @__PURE__ */ jsx21(Outlet7, {}) });
};
var createProfileSearchRoutes = () => {
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx21(ProfileRoute, {}),
      children: createProfileSearchContainerRoutes()
    }
  ];
};

// src/secure/talent-pools/TalentPoolsLayout.tsx
import { useCallback as useCallback8 } from "react";
import { Navigate as Navigate10, useNavigate as useNavigate7 } from "react-router-dom";
import { OutletRoute as OutletRoute6 } from "app-core";
import { TalentPoolListContainer } from "feature-recruit";

// src/secure/talent-pools/components/__generated__/EmployerTalentPoolRouteQuery.graphql.ts
var node6 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "theme",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabled",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inviteOnly",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "customInviteLink",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "joinDeclinedLink",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitTalentPoolTheme",
    "kind": "LinkedField",
    "name": "customTheme",
    "plural": false,
    "selections": [
      v2,
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logoUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroBgColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroBorderColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroTextColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryButtonTextColor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v14 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerTalentPoolRouteQuery",
      "selections": [
        {
          "alias": "talentPool",
          "args": v1,
          "concreteType": "RecruitTalentPool",
          "kind": "LinkedField",
          "name": "recruitTalentPoolByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolContainer_talentPool"
            },
            v14
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerTalentPoolRouteQuery",
      "selections": [
        {
          "alias": "talentPool",
          "args": v1,
          "concreteType": "RecruitTalentPool",
          "kind": "LinkedField",
          "name": "recruitTalentPoolByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "7b52e9b53ab1e0d4d2275b69dc9a204c",
      "id": null,
      "metadata": {},
      "name": "EmployerTalentPoolRouteQuery",
      "operationKind": "query",
      "text": "query EmployerTalentPoolRouteQuery(\n  $talentPoolCode: Int!\n) {\n  talentPool: recruitTalentPoolByCode(code: $talentPoolCode) {\n    id\n    code\n    talentPoolId\n    name\n    description\n    theme\n    enabled\n    inviteOnly\n    slug\n    customInviteLink\n    joinDeclinedLink\n    customTheme {\n      id\n      name\n      primaryColor\n      logoUrl\n      heroBgColor\n      heroBorderColor\n      heroTextColor\n      primaryButtonTextColor\n    }\n    ...TalentPoolContainer_talentPool\n  }\n}\n\nfragment TalentPoolContainer_talentPool on RecruitTalentPool {\n  id\n  talentPoolId\n  name\n  description\n  theme\n  enabled\n  inviteOnly\n  slug\n  customInviteLink\n  joinDeclinedLink\n  customTheme {\n    id\n    name\n    primaryColor\n    logoUrl\n    heroBgColor\n    heroBorderColor\n    heroTextColor\n    primaryButtonTextColor\n  }\n  ...TalentPoolUpdateEditor_talentPool\n}\n\nfragment TalentPoolUpdateEditor_talentPool on RecruitTalentPool {\n  id\n  talentPoolId\n  name\n  description\n  theme\n  enabled\n  inviteOnly\n  slug\n  customInviteLink\n  joinDeclinedLink\n  customTheme {\n    id\n    name\n    primaryColor\n    logoUrl\n    heroBgColor\n    heroBorderColor\n    heroTextColor\n    primaryButtonTextColor\n  }\n}\n"
    }
  };
}();
node6.hash = "e5ac354ae2f34035af19962e6c910ef0";
var EmployerTalentPoolRouteQuery_graphql_default = node6;

// src/secure/talent-pools/components/EmployerTalentPoolRoute.tsx
import { Navigate as Navigate9, useRouteLoaderData } from "react-router-dom";
import {
  loadQuery as loadQuery3,
  usePreloadedQuery as usePreloadedQuery2
} from "react-relay";
import { OutletRoute as OutletRoute5 } from "app-core";
import { TalentPoolVacancies } from "feature-recruit";

// src/secure/talent-pools/components/EmployerTalentPoolLayout.tsx
import { Outlet as Outlet8, useLocation } from "react-router-dom";
import { UsersIcon as UsersIcon2 } from "@heroicons/react/24/outline";
import { useRouteData } from "shared-lib";
import { createLinkState, EdSkeleton as EdSkeleton9, HeaderBar, Tabs } from "shared-ui";
import { jsx as jsx22, jsxs as jsxs12 } from "react/jsx-runtime";
var EmployerTalentPoolLayout = ({
  showExpandSection,
  routeId
}) => {
  const data = useRouteData(
    talentPoolRouteQueryDef,
    routeId
  );
  const location = useLocation();
  const tabs = [
    createLinkState(location, "Details", `details`, UsersIcon2),
    createLinkState(location, "Invites", `invites`, UsersIcon2),
    createLinkState(location, "Members", `members`, UsersIcon2),
    createLinkState(location, "Vacancies", `vacancies`, UsersIcon2)
  ];
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx22(EdSkeleton9, {});
  }
  return /* @__PURE__ */ jsxs12("div", { className: "@container flex w-full flex-1 flex-col", children: [
    /* @__PURE__ */ jsx22(HeaderBar, { title: `Talent Pools: ${talentPool.name}` }),
    /* @__PURE__ */ jsxs12("div", { className: "container mx-auto p-2 md:p-5", children: [
      /* @__PURE__ */ jsx22("div", { className: "", children: /* @__PURE__ */ jsx22(Tabs, { tabs }) }),
      /* @__PURE__ */ jsx22("div", { className: "my-2 rounded-xl bg-white ", children: /* @__PURE__ */ jsx22("div", { children: /* @__PURE__ */ jsx22(Outlet8, {}) }) })
    ] })
  ] });
};

// src/secure/talent-pools/components/EmployerTalentPoolDetails.tsx
import { Suspense as Suspense12 } from "react";
import { useRouteData as useRouteData2 } from "shared-lib";
import { EdSkeleton as EdSkeleton10 } from "shared-ui";
import { TalentPoolContainer } from "feature-recruit";
import { Fragment as Fragment2, jsx as jsx23 } from "react/jsx-runtime";
var EmployerTalentPoolDetails = ({ routeId }) => {
  const data = useRouteData2(
    talentPoolRouteQueryDef,
    routeId
  );
  if (!data) {
    return /* @__PURE__ */ jsx23(Fragment2, { children: "Loading..." });
  }
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx23(EdSkeleton10, {});
  }
  return /* @__PURE__ */ jsx23(Suspense12, { fallback: /* @__PURE__ */ jsx23(EdSkeleton10, {}), children: /* @__PURE__ */ jsx23(TalentPoolContainer, { fragmentRef: talentPool }) });
};

// src/secure/talent-pools/components/EmployerTalentPoolAnalysisRoute.tsx
import { Suspense as Suspense16 } from "react";
import { Link as Link2, Navigate as Navigate6, Outlet as Outlet9, useLocation as useLocation2 } from "react-router-dom";
import {
  ChartBarIcon,
  UserGroupIcon as UserGroupIcon2,
  UsersIcon as UsersIcon3
} from "@heroicons/react/24/outline";
import { createLinkState as createLinkState2, EdSkeleton as EdSkeleton14, TabPills } from "shared-ui";

// src/secure/talent-pools/components/__generated__/EmployerTalentPoolAnalysisEscoQuery.graphql.ts
var node7 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "occurrenceCount",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parentCode",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasParent",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "data",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerTalentPoolAnalysisEscoQuery",
      "selections": [
        {
          "alias": "tree",
          "args": v1,
          "concreteType": "RecruitTalentPoolAnalysisEscoTree",
          "kind": "LinkedField",
          "name": "recruitTalentPoolAnalysisEscoByCode",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EscoTree_tree"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerTalentPoolAnalysisEscoQuery",
      "selections": [
        {
          "alias": "tree",
          "args": v1,
          "concreteType": "RecruitTalentPoolAnalysisEscoTree",
          "kind": "LinkedField",
          "name": "recruitTalentPoolAnalysisEscoByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolAnalysisEscoTree",
              "kind": "LinkedField",
              "name": "children",
              "plural": true,
              "selections": [
                v2,
                v3,
                v4,
                v5,
                v6,
                v7,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": true,
                  "selections": [
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                      "kind": "LinkedField",
                      "name": "children",
                      "plural": true,
                      "selections": [
                        v2,
                        v3,
                        v4,
                        v5,
                        v6,
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                          "kind": "LinkedField",
                          "name": "children",
                          "plural": true,
                          "selections": [
                            v2,
                            v3,
                            v5,
                            v4,
                            v6,
                            v7,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                v2,
                                v3,
                                v5,
                                v4,
                                v6,
                                v7,
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    v3
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fef496ca403c2e0be1cfc1839a48040e",
      "id": null,
      "metadata": {},
      "name": "EmployerTalentPoolAnalysisEscoQuery",
      "operationKind": "query",
      "text": "query EmployerTalentPoolAnalysisEscoQuery(\n  $talentPoolCode: Int!\n) {\n  tree: recruitTalentPoolAnalysisEscoByCode(code: $talentPoolCode) {\n    ...EscoTree_tree\n  }\n}\n\nfragment EscoTree_node on RecruitTalentPoolAnalysisEscoTree {\n  code\n  name\n  occurrenceCount\n  parentCode\n  hasParent\n  data\n  children {\n    code\n    name\n    occurrenceCount\n    parentCode\n    hasParent\n    data\n    children {\n      code\n      name\n      occurrenceCount\n      parentCode\n      hasParent\n      data\n      children {\n        code\n        name\n        occurrenceCount\n        parentCode\n        hasParent\n        data\n        children {\n          code\n          name\n          parentCode\n          occurrenceCount\n          hasParent\n          data\n          children {\n            code\n            name\n            parentCode\n            occurrenceCount\n            hasParent\n            data\n            children {\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EscoTree_tree on RecruitTalentPoolAnalysisEscoTree {\n  ...EscoTree_node\n}\n"
    }
  };
}();
node7.hash = "8e3db21f4ddd1a4c4df4a52bcc689e2c";
var EmployerTalentPoolAnalysisEscoQuery_graphql_default = node7;

// src/secure/talent-pools/components/EmployerTalentPoolAnalysisEsco.tsx
import { Suspense as Suspense13 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery3 } from "react-relay";
import { EdSkeleton as EdSkeleton11 } from "shared-ui";

// src/secure/talent-pools/components/__generated__/EscoTree_tree.graphql.ts
var node8 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EscoTree_tree",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EscoTree_node"
    }
  ],
  "type": "RecruitTalentPoolAnalysisEscoTree",
  "abstractKey": null
};
node8.hash = "d6f7363337a8dc8041326ceba28eab9e";
var EscoTree_tree_graphql_default = node8;

// src/secure/talent-pools/components/__generated__/EscoTree_node.graphql.ts
var node9 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "occurrenceCount",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parentCode",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasParent",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "data",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EscoTree_node",
    "selections": [
      v0,
      v1,
      v2,
      v3,
      v4,
      v5,
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPoolAnalysisEscoTree",
        "kind": "LinkedField",
        "name": "children",
        "plural": true,
        "selections": [
          v0,
          v1,
          v2,
          v3,
          v4,
          v5,
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPoolAnalysisEscoTree",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": [
              v0,
              v1,
              v2,
              v3,
              v4,
              v5,
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  v0,
                  v1,
                  v2,
                  v3,
                  v4,
                  v5,
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      v0,
                      v1,
                      v3,
                      v2,
                      v4,
                      v5,
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          v0,
                          v1,
                          v3,
                          v2,
                          v4,
                          v5,
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RecruitTalentPoolAnalysisEscoTree",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": true,
                            "selections": [
                              v1
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitTalentPoolAnalysisEscoTree",
    "abstractKey": null
  };
}();
node9.hash = "9745e37a355c670af46c331af90c6b2f";
var EscoTree_node_graphql_default = node9;

// src/secure/talent-pools/components/EscoTree.tsx
import { useFragment } from "react-relay";
import { SunburstChart } from "shared-ui";

// src/secure/talent-pools/lib/EscoTree.ts
var isHierarchyNode = (b) => {
  return b.data.level !== void 0;
};
var colors = {
  0: "#F4992A",
  1: "#F4A33F",
  2: "#F5AC53",
  3: "#F5B668",
  4: "#F6BF7C",
  5: "#F6C487",
  6: "#F6CD9B"
};
function toChartNode(node12) {
  if (isHierarchyNode(node12)) {
    return {
      color: colors[0],
      loc: node12.occurrenceCount,
      name: node12.name,
      children: node12.children.map(toChartNode)
    };
  } else {
    return {
      color: colors[0],
      loc: node12.occurrenceCount,
      name: node12.name,
      children: node12.children.map(toChartNode)
    };
  }
}
function buildEscoSunburstFromTree(tree) {
  return {
    children: tree.children.map(toChartNode)
  };
}

// src/secure/talent-pools/components/EscoTree.tsx
import { jsx as jsx24, jsxs as jsxs13 } from "react/jsx-runtime";
var fragmentDef = EscoTree_tree_graphql_default;
var EscoTree = ({ fragmentRef }) => {
  const data = useFragment(fragmentDef, fragmentRef);
  return /* @__PURE__ */ jsx24("div", { className: "flex flex-col gap-2 bg-white p-2", children: /* @__PURE__ */ jsx24(EscoRoot, { fragmentRef: data }) });
};
var EscoRoot = ({ fragmentRef }) => {
  const data = useFragment(rootFragmentDef, fragmentRef);
  const tree = buildEscoSunburstFromTree(data);
  return /* @__PURE__ */ jsx24("div", { className: "flex flex-col gap-2 border bg-white p-2", children: /* @__PURE__ */ jsx24(EscoSunburstChart, { root: tree }) });
};
var rootFragmentDef = EscoTree_node_graphql_default;
var EscoSunburstChart = ({ root }) => {
  return /* @__PURE__ */ jsxs13("div", { className: "flex h-96 justify-center p-2", children: [
    /* @__PURE__ */ jsx24("div", { className: "flex-1", children: /* @__PURE__ */ jsx24(SunburstChart, { data: root }) }),
    /* @__PURE__ */ jsxs13("div", { className: "flex w-1/4 flex-col gap-3 divide-y", children: [
      /* @__PURE__ */ jsx24("div", { className: "p-2", children: "Level 1" }),
      /* @__PURE__ */ jsx24("div", { className: "p-2", children: "Level 2" }),
      /* @__PURE__ */ jsx24("div", { className: "p-2", children: "Level 3" })
    ] })
  ] });
};

// src/secure/talent-pools/components/EmployerTalentPoolAnalysisEsco.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var queryDef4 = EmployerTalentPoolAnalysisEscoQuery_graphql_default;
var EmployerTalentPoolAnalysisEsco = ({ routeId }) => {
  const data = useTalentPoolRouteData(routeId);
  const { talentPool } = data;
  const query = useLazyLoadQuery3(
    queryDef4,
    {
      talentPoolCode: talentPool.code
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { tree } = query;
  if (!tree) {
    return /* @__PURE__ */ jsx25(EdSkeleton11, {});
  }
  return /* @__PURE__ */ jsx25(Suspense13, { fallback: /* @__PURE__ */ jsx25(EdSkeleton11, {}), children: /* @__PURE__ */ jsx25("div", { className: "flex flex-col gap-2 bg-white p-2", children: /* @__PURE__ */ jsx25(EscoTree, { fragmentRef: tree }) }) });
};

// src/secure/talent-pools/components/EmployerTalentPoolAnalysisMembers.tsx
import { Suspense as Suspense14 } from "react";
import { EdSkeleton as EdSkeleton12 } from "shared-ui";
import { jsx as jsx26 } from "react/jsx-runtime";
var EmployerTalentPoolAnalysisMembers = ({ routeId }) => {
  const data = useTalentPoolRouteData(routeId);
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx26(EdSkeleton12, {});
  }
  return /* @__PURE__ */ jsx26(Suspense14, { fallback: /* @__PURE__ */ jsx26(EdSkeleton12, {}), children: /* @__PURE__ */ jsx26("div", { className: "flex flex-col bg-white p-2", children: "Members" }) });
};

// src/secure/talent-pools/components/EmployerTalentPoolAnalysisSkills.tsx
import { Suspense as Suspense15 } from "react";
import { EdSkeleton as EdSkeleton13 } from "shared-ui";
import { jsx as jsx27 } from "react/jsx-runtime";
var EmployerTalentPoolAnalysisSkills = ({ routeId }) => {
  const data = useTalentPoolRouteData(routeId);
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx27(EdSkeleton13, {});
  }
  return /* @__PURE__ */ jsx27(Suspense15, { fallback: /* @__PURE__ */ jsx27(EdSkeleton13, {}), children: /* @__PURE__ */ jsx27("div", { className: "flex flex-col bg-white p-2", children: "Skills" }) });
};

// src/secure/talent-pools/components/EmployerTalentPoolAnalysisRoute.tsx
import { jsx as jsx28, jsxs as jsxs14 } from "react/jsx-runtime";
var EmployerTalentPoolAnalysisLayout = ({ routeId }) => {
  const location = useLocation2();
  const data = useTalentPoolRouteData(routeId);
  const { talentPool } = data;
  const tabs = [
    createLinkState2(location, "Esco", `esco`, UsersIcon3),
    createLinkState2(location, "Members", `members`, UserGroupIcon2),
    createLinkState2(location, "Skills", `skills`, ChartBarIcon)
  ];
  if (!talentPool) {
    return /* @__PURE__ */ jsx28(EdSkeleton14, {});
  }
  return /* @__PURE__ */ jsx28(Suspense16, { fallback: /* @__PURE__ */ jsx28(EdSkeleton14, {}), children: /* @__PURE__ */ jsxs14("div", { className: "flex flex-col ", children: [
    /* @__PURE__ */ jsxs14("div", { className: "flex items-center justify-between border-b p-2", children: [
      /* @__PURE__ */ jsx28("div", { children: "Analytics" }),
      /* @__PURE__ */ jsx28("div", { children: /* @__PURE__ */ jsx28(TabPills, { tabs }) })
    ] }),
    /* @__PURE__ */ jsx28("div", { children: /* @__PURE__ */ jsx28(Outlet9, {}) })
  ] }) });
};
var createRoute = (parentRouteId, environment, context) => {
  const routeId = `${parentRouteId}-analysis`;
  return {
    id: routeId,
    path: "*",
    element: /* @__PURE__ */ jsx28(EmployerTalentPoolAnalysisLayout, { routeId: parentRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx28(Link2, { to: "analysis", children: "Analysis" })
    },
    children: [
      {
        id: `${routeId}-esco`,
        path: "esco",
        element: /* @__PURE__ */ jsx28(EmployerTalentPoolAnalysisEsco, { routeId: parentRouteId })
      },
      {
        id: `${routeId}-members`,
        path: "members",
        element: /* @__PURE__ */ jsx28(EmployerTalentPoolAnalysisMembers, { routeId: parentRouteId })
      },
      {
        id: `${routeId}-skills`,
        path: "skills",
        element: /* @__PURE__ */ jsx28(EmployerTalentPoolAnalysisSkills, { routeId: parentRouteId })
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx28(Navigate6, { to: "esco", replace: true })
      }
    ]
  };
};

// src/secure/talent-pools/components/EmployerTalentPoolInvitesRoute.tsx
import { useCallback as useCallback4 } from "react";
import { Link as Link3, Navigate as Navigate7, useNavigate as useNavigate3 } from "react-router-dom";
import { Suspense as Suspense18 } from "shared-ui";
import { EdSkeleton as EdSkeleton16 } from "shared-ui";
import { OutletRoute as OutletRoute3 } from "app-core";
import { TalentPoolInvitesListContainer } from "feature-recruit";

// src/secure/talent-pools/components/__generated__/EmployerTalentPoolInviteRouteQuery.graphql.ts
var node10 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolInviteCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolInviteCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolInviteId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "source",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateFirstName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateLastName",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateEmail",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v17 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerTalentPoolInviteRouteQuery",
      "selections": [
        {
          "alias": "invite",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v14,
                v15,
                v16
              ],
              "storageKey": null
            },
            v17
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerTalentPoolInviteRouteQuery",
      "selections": [
        {
          "alias": "invite",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v14,
                v15,
                v16,
                v2
              ],
              "storageKey": null
            },
            v17
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d78248a2b8950e8645705972cdcb8809",
      "id": null,
      "metadata": {},
      "name": "EmployerTalentPoolInviteRouteQuery",
      "operationKind": "query",
      "text": "query EmployerTalentPoolInviteRouteQuery(\n  $talentPoolInviteCode: Int!\n) {\n  invite: recruitTalentPoolInviteByCode(code: $talentPoolInviteCode) {\n    id\n    talentPoolInviteId\n    code\n    updatedAt\n    talentPoolId\n    candidateId\n    status\n    source\n    candidateFirstName\n    candidateLastName\n    candidateEmail\n    sourceId\n    candidate {\n      firstName\n      lastName\n      email\n      id\n    }\n  }\n}\n"
    }
  };
}();
node10.hash = "9f45edd29eca735f7995902ffb7050b3";
var EmployerTalentPoolInviteRouteQuery_graphql_default = node10;

// src/secure/talent-pools/components/EmployerTalentPoolInviteRoute.tsx
import { Fragment as Fragment3, useCallback as useCallback3 } from "react";
import { useNavigate as useNavigate2 } from "react-router-dom";
import { loadQuery } from "react-relay";
import { createClientMutationId as createClientMutationId2, useRouteData as useRouteData3, useToggle } from "shared-lib";
import {
  Button as Button6,
  DescriptionItem,
  DescriptionList,
  EdSkeleton as EdSkeleton15,
  Size as Size3,
  Suspense as Suspense17
} from "shared-ui";
import {
  useTalentPoolInviteExpire
} from "feature-recruit";
import { Fragment as Fragment4, jsx as jsx29, jsxs as jsxs15 } from "react/jsx-runtime";
var queryDef5 = EmployerTalentPoolInviteRouteQuery_graphql_default;
async function loader(environment, params) {
  const code = params.talentPoolInviteCode;
  const talentPoolInviteCode = parseInt(code);
  return loadQuery(environment, queryDef5, {
    talentPoolInviteCode
  });
}
var EmployerTalentPoolInviteRoute = ({ routeId }) => {
  const navigate = useNavigate2();
  const [expireInvite, isExpiringInvite] = useTalentPoolInviteExpire();
  const [isEditing, toggleIsEditing] = useToggle();
  const [isRemoving, toggleIsRemoving] = useToggle();
  const data = useRouteData3(
    queryDef5,
    routeId
  );
  const { invite } = data;
  const onExpireInvite = useCallback3(async () => {
    if (!invite) {
      return;
    }
    const input = {
      id: invite.talentPoolInviteId,
      clientMutationId: createClientMutationId2()
    };
    const response = await expireInvite({ input });
    if (response.data.payload) {
      navigate(`../`);
    }
  }, [expireInvite, invite, navigate]);
  if (!data) {
    return /* @__PURE__ */ jsx29(Fragment4, { children: "Loading..." });
  }
  if (!invite) {
    return /* @__PURE__ */ jsx29(EdSkeleton15, {});
  }
  return /* @__PURE__ */ jsx29(Suspense17, { fallback: /* @__PURE__ */ jsx29(EdSkeleton15, {}), children: /* @__PURE__ */ jsx29("div", { className: "flex-1", children: /* @__PURE__ */ jsxs15("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs15("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
      /* @__PURE__ */ jsxs15("div", { className: "flex items-center gap-4 pt-2 text-sm", children: [
        /* @__PURE__ */ jsxs15("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx29("div", { className: "text-primary-700 text-xl font-bold", children: invite.candidateFirstName }),
          /* @__PURE__ */ jsx29("div", { className: "text-primary-700 text-xl font-bold", children: invite.candidateLastName })
        ] }),
        /* @__PURE__ */ jsxs15("div", { className: "flex items-center gap-2 pt-1 text-sm", children: [
          /* @__PURE__ */ jsx29("div", { className: "text-primary-700 text-sm font-bold", children: invite.code }),
          /* @__PURE__ */ jsx29("div", { className: "text-md text-blue-700", children: invite.status })
        ] })
      ] }),
      /* @__PURE__ */ jsxs15("div", { className: "flex items-center gap-2", children: [
        invite.status !== "Withdrawn" && /* @__PURE__ */ jsx29(Button6, { color: "warning", clicked: toggleIsRemoving, children: "Expire" }),
        isEditing ? /* @__PURE__ */ jsx29(Button6, { color: "gray", clicked: toggleIsEditing, children: "Cancel" }) : /* @__PURE__ */ jsx29(Button6, { color: "primary", clicked: toggleIsEditing, children: "Edit" })
      ] })
    ] }),
    isRemoving && /* @__PURE__ */ jsx29("div", { className: "m-8 flex items-center justify-center", children: /* @__PURE__ */ jsx29("div", { className: "sm:w-1/2", children: /* @__PURE__ */ jsx29(
      Button6,
      {
        color: "warning",
        size: Size3.xl,
        clicked: onExpireInvite,
        disabled: isExpiringInvite,
        children: "Expire, Are you Sure ?"
      }
    ) }) }),
    isEditing ? /* @__PURE__ */ jsx29("div", { className: "m-4 border border-gray-100", children: "Editing" }) : /* @__PURE__ */ jsx29(
      DescriptionList,
      {
        classes: "w-full",
        heading: /* @__PURE__ */ jsx29("div", { className: "flex items-center", children: "Invite" }),
        items: /* @__PURE__ */ jsxs15(Fragment3, { children: [
          /* @__PURE__ */ jsx29(DescriptionItem, { label: "First Name", children: invite.candidateFirstName }),
          /* @__PURE__ */ jsx29(DescriptionItem, { label: "Last Name", children: invite.candidateLastName }),
          /* @__PURE__ */ jsx29(DescriptionItem, { label: "Email", children: invite.candidateEmail }),
          /* @__PURE__ */ jsx29(DescriptionItem, { label: "source", children: invite.source })
        ] })
      }
    )
  ] }) }) });
};
var createRoute2 = (routePrefix, environment, context, inList = true) => {
  const routeId = `${routePrefix}-invite`;
  return {
    id: routeId,
    path: ":talentPoolInviteCode",
    element: /* @__PURE__ */ jsx29(EmployerTalentPoolInviteRoute, { routeId, inList }),
    loader: ({ params }) => {
      return loader(environment, params);
    }
  };
};

// src/secure/talent-pools/components/EmployerTalentPoolInvitesRoute.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var EmployerTalentPoolInvitesRoute = ({ routeId }) => {
  const navigate = useNavigate3();
  const data = useTalentPoolRouteData(routeId);
  const { talentPool } = data;
  const onCreate = useCallback4(() => {
    navigate("../../../create-invite");
  }, [navigate]);
  if (!talentPool) {
    return /* @__PURE__ */ jsx30(EdSkeleton16, {});
  }
  return /* @__PURE__ */ jsx30(Suspense18, { fallback: /* @__PURE__ */ jsx30(EdSkeleton16, {}), children: /* @__PURE__ */ jsx30(
    TalentPoolInvitesListContainer,
    {
      talentPoolId: talentPool.talentPoolId,
      onCreate
    }
  ) });
};
var createRoute3 = (parentRouteId, environment, context) => {
  const routeId = `${parentRouteId}-invites`;
  const listRouteId = `${routeId}-list`;
  return {
    id: routeId,
    path: "*",
    element: /* @__PURE__ */ jsx30(OutletRoute3, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx30(Link3, { to: "invites", children: "Invites" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx30(EmployerTalentPoolInvitesRoute, { routeId: parentRouteId }),
        children: [createRoute2(listRouteId, environment, context, true)]
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx30(Navigate7, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/talent-pools/components/EmployerTalentPoolMembersRoute.tsx
import { useCallback as useCallback6 } from "react";
import { Link as Link4, Navigate as Navigate8, useNavigate as useNavigate5 } from "react-router-dom";
import { Suspense as Suspense20 } from "shared-ui";
import { EdSkeleton as EdSkeleton18 } from "shared-ui";
import { OutletRoute as OutletRoute4 } from "app-core";
import { TalentPoolMemberListContainer } from "feature-recruit";

// src/secure/talent-pools/components/__generated__/EmployerTalentPoolMemberRouteQuery.graphql.ts
var node11 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolMemberCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "talentPoolMemberCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerTalentPoolMemberRouteQuery",
      "selections": [
        {
          "alias": "member",
          "args": v1,
          "concreteType": "RecruitTalentPoolMembership",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolMemberContainer_member"
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerTalentPoolMemberRouteQuery",
      "selections": [
        {
          "alias": "member",
          "args": v1,
          "concreteType": "RecruitTalentPoolMembership",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "talentPoolMembershipId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "talentPoolId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                },
                v2
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c3b482ca633b8871a89d2739b51096a5",
      "id": null,
      "metadata": {},
      "name": "EmployerTalentPoolMemberRouteQuery",
      "operationKind": "query",
      "text": "query EmployerTalentPoolMemberRouteQuery(\n  $talentPoolMemberCode: Long!\n) {\n  member: recruitTalentPoolMembershipByCode(code: $talentPoolMemberCode) {\n    id\n    code\n    ...TalentPoolMemberContainer_member\n  }\n}\n\nfragment TalentPoolMemberContainer_member on RecruitTalentPoolMembership {\n  id\n  talentPoolMembershipId\n  code\n  talentPoolId\n  status\n  updatedOn\n  profile {\n    recruitProfileId\n    firstName\n    lastName\n    emailAddress\n    id\n  }\n}\n"
    }
  };
}();
node11.hash = "4c4e370fe5653ab2e336687a772de225";
var EmployerTalentPoolMemberRouteQuery_graphql_default = node11;

// src/secure/talent-pools/components/EmployerTalentPoolMemberRoute.tsx
import { useCallback as useCallback5 } from "react";
import { useNavigate as useNavigate4 } from "react-router-dom";
import { loadQuery as loadQuery2 } from "react-relay";
import { Suspense as Suspense19 } from "shared-ui";
import { useRouteData as useRouteData4 } from "shared-lib";
import { EdSkeleton as EdSkeleton17 } from "shared-ui";
import { TalentPoolMemberContainer } from "feature-recruit";
import { jsx as jsx31 } from "react/jsx-runtime";
var queryDef6 = EmployerTalentPoolMemberRouteQuery_graphql_default;
async function loader2(environment, params) {
  const code = params.talentPoolMemberCode;
  const talentPoolMemberCode = parseInt(code);
  return loadQuery2(environment, queryDef6, {
    talentPoolMemberCode
  });
}
var EmployerTalentPoolMemberRoute = ({ routeId }) => {
  const navigate = useNavigate4();
  const data = useRouteData4(
    queryDef6,
    routeId
  );
  const onRevoked = useCallback5(() => {
    navigate("../");
  }, [navigate]);
  const { member } = data;
  if (!member) {
    return /* @__PURE__ */ jsx31(EdSkeleton17, {});
  }
  return /* @__PURE__ */ jsx31(Suspense19, { fallback: /* @__PURE__ */ jsx31(EdSkeleton17, {}), children: /* @__PURE__ */ jsx31("div", { className: "flex-1", children: /* @__PURE__ */ jsx31(TalentPoolMemberContainer, { onRevoked, fragmentRef: member }) }) });
};
var createRoute4 = (routePrefix, environment, context, inList = true) => {
  const routeId = `${routePrefix}-member`;
  return {
    id: routeId,
    path: ":talentPoolMemberCode",
    element: /* @__PURE__ */ jsx31(EmployerTalentPoolMemberRoute, { routeId, inList }),
    loader: ({ params }) => {
      return loader2(environment, params);
    }
  };
};

// src/secure/talent-pools/components/EmployerTalentPoolMembersRoute.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var EmployerTalentPoolMembersRoute = ({ routeId }) => {
  const navigate = useNavigate5();
  const data = useTalentPoolRouteData(routeId);
  const { talentPool } = data;
  const onCreate = useCallback6(() => {
    navigate("../../../create-invite");
  }, [navigate]);
  if (!talentPool) {
    return /* @__PURE__ */ jsx32(EdSkeleton18, {});
  }
  return /* @__PURE__ */ jsx32(Suspense20, { fallback: /* @__PURE__ */ jsx32(EdSkeleton18, {}), children: /* @__PURE__ */ jsx32("div", { children: /* @__PURE__ */ jsx32(
    TalentPoolMemberListContainer,
    {
      talentPoolId: talentPool.talentPoolId,
      onCreate
    }
  ) }) });
};
var createRoute5 = (parentRouteId, environment, context) => {
  const routeId = `${parentRouteId}-members`;
  const listRouteId = `${routeId}-list`;
  return {
    id: routeId,
    path: "*",
    element: /* @__PURE__ */ jsx32(OutletRoute4, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx32(Link4, { to: "members", children: "Members" })
    },
    children: [
      {
        id: listRouteId,
        path: "list",
        element: /* @__PURE__ */ jsx32(EmployerTalentPoolMembersRoute, { routeId: parentRouteId }),
        children: [createRoute4(listRouteId, environment, context, true)]
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx32(Navigate8, { to: "list", replace: true })
      }
    ]
  };
};

// src/secure/talent-pools/components/EmployerTalentPoolCreateInviteRoute.tsx
import { useCallback as useCallback7 } from "react";
import { useNavigate as useNavigate6 } from "react-router-dom";
import { Suspense as Suspense21 } from "shared-ui";
import { EdSkeleton as EdSkeleton19 } from "shared-ui";
import { TalentPoolCreateInviteContainer } from "feature-recruit";
import { jsx as jsx33 } from "react/jsx-runtime";
var EmployerTalentPoolCreateInviteRoute = ({ parentRouteId }) => {
  const data = useTalentPoolRouteData(parentRouteId);
  const navigate = useNavigate6();
  const onDone = useCallback7(
    (talentPoolInviteId) => {
      navigate(`../${talentPoolInviteId}`);
    },
    [navigate]
  );
  const onCancel = useCallback7(() => {
    navigate(-1);
  }, [navigate]);
  const { talentPool } = data;
  if (!talentPool) {
    return /* @__PURE__ */ jsx33(EdSkeleton19, {});
  }
  return /* @__PURE__ */ jsx33(Suspense21, { fallback: /* @__PURE__ */ jsx33(EdSkeleton19, {}), children: /* @__PURE__ */ jsx33(
    TalentPoolCreateInviteContainer,
    {
      talentPool,
      onDone,
      onCancel
    }
  ) });
};
var createRoute6 = (parentRouteId, environment, context, inList = true) => {
  const routeId = `${parentRouteId}-create-invite`;
  return {
    id: routeId,
    path: "create-invite",
    element: /* @__PURE__ */ jsx33(
      EmployerTalentPoolCreateInviteRoute,
      {
        parentRouteId,
        routeId,
        inList
      }
    )
  };
};

// src/secure/talent-pools/components/EmployerTalentPoolRoute.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var talentPoolRouteQueryDef = EmployerTalentPoolRouteQuery_graphql_default;
async function loader3(environment, params) {
  const code = params.talentPoolCode;
  const talentPoolCode = parseInt(code);
  return loadQuery3(
    environment,
    talentPoolRouteQueryDef,
    {
      talentPoolCode
    }
  );
}
function useTalentPoolRouteData(routeId) {
  const queryRef = useRouteLoaderData(
    routeId
  );
  const data = usePreloadedQuery2(
    talentPoolRouteQueryDef,
    queryRef
  );
  return data;
}
var createRoute7 = (routePrefix, environment, context, inList = true) => {
  const routeId = `${routePrefix}-talent-pool`;
  return {
    id: routeId,
    path: ":talentPoolCode",
    element: /* @__PURE__ */ jsx34(EmployerTalentPoolLayout, { routeId, showExpandSection: inList }),
    loader: ({ params }) => {
      return loader3(environment, params);
    },
    children: [
      {
        id: `${routeId}-details`,
        path: "details/*",
        element: /* @__PURE__ */ jsx34("div", { className: "flex-1", children: /* @__PURE__ */ jsx34(EmployerTalentPoolDetails, { routeId, inList }) })
      },
      {
        path: "analytics/*",
        element: /* @__PURE__ */ jsx34(OutletRoute5, {}),
        children: [createRoute(routeId, environment, context)]
      },
      {
        path: "invites/*",
        element: /* @__PURE__ */ jsx34(OutletRoute5, {}),
        children: [createRoute3(routeId, environment, context)]
      },
      {
        path: "members/*",
        element: /* @__PURE__ */ jsx34(OutletRoute5, {}),
        children: [createRoute5(routeId, environment, context)]
      },
      {
        path: "vacancies/*",
        loader: ({ params }) => {
          return TalentPoolVacancies.loader(environment, params);
        },
        element: /* @__PURE__ */ jsx34(TalentPoolVacancies, { routeId })
      },
      createRoute6(routeId, environment, context, false),
      {
        path: "*",
        element: /* @__PURE__ */ jsx34(Navigate9, { to: "details", replace: true })
      }
    ]
  };
};

// src/secure/talent-pools/TalentPoolsLayout.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var List = () => {
  const navigate = useNavigate7();
  const onCreate = useCallback8(() => {
    navigate(`../create`);
  }, [navigate]);
  return /* @__PURE__ */ jsx35(TalentPoolListContainer, { onCreate });
};
var createTalentPoolsRoutes = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-talent-pools`;
  const listRouteId = `${routeId}-list`;
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx35(OutletRoute6, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx35(List, {}),
          children: [
            createRoute7(listRouteId, environment, context, true)
          ]
        },
        createRoute7(routeId, environment, context, false),
        {
          path: "*",
          element: /* @__PURE__ */ jsx35(Navigate10, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/secure/recommendations/RecommendationsRoute.tsx
import { Suspense as Suspense22 } from "react";
import { Navigate as Navigate11, Outlet as Outlet10 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary8 } from "react-error-boundary";
import { EdSkeleton as EdSkeleton20, HeaderBar as HeaderBar2 } from "shared-ui";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback7,
  useUserSessionContext as useUserSessionContext6
} from "app-core";
import { VacancyRecommendationSearchContainer } from "feature-recruit";
import { jsx as jsx36, jsxs as jsxs16 } from "react/jsx-runtime";
var RecommendationsRoute = () => {
  return /* @__PURE__ */ jsx36(ErrorBoundary8, { FallbackComponent: ErrorBoundaryFallback7, children: /* @__PURE__ */ jsx36(Outlet10, {}) });
};
var RecommendationsListRoute = () => {
  const session = useUserSessionContext6();
  return /* @__PURE__ */ jsxs16(Suspense22, { fallback: /* @__PURE__ */ jsx36(EdSkeleton20, {}), children: [
    /* @__PURE__ */ jsx36(HeaderBar2, { title: "Recommendations" }),
    /* @__PURE__ */ jsx36(VacancyRecommendationSearchContainer, {})
  ] });
};
var createRecommendationsRoutes = (environment, context) => {
  return [
    {
      path: "list/*",
      element: /* @__PURE__ */ jsx36(RecommendationsListRoute, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx36(Navigate11, { to: "list", replace: true })
    }
  ];
};

// src/secure/AppEmployersSecureLayout.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var AppErrorPage = () => {
  return /* @__PURE__ */ jsx37("div", { children: "AppErrorPage" });
};
var queryDef7 = AppEmployersSecureLayoutQuery_graphql_default;
var AppEmployersSecureRoutes = (environment, context) => {
  return [
    {
      index: true,
      element: /* @__PURE__ */ jsx37(Navigate12, { to: "/employers/app/vacancies/list", replace: true })
    },
    {
      path: "account/*",
      element: /* @__PURE__ */ jsx37(AccountPage, {})
    },
    {
      path: "settings/*",
      element: /* @__PURE__ */ jsx37(OutletRoute7, {}),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => /* @__PURE__ */ jsx37(Link5, { to: "/employers/app/settings", children: "Settings" })
      },
      children: createSettingsRoutes(environment, context)
    },
    {
      path: "profile-search/*",
      element: /* @__PURE__ */ jsx37(OutletRoute7, {}),
      children: createProfileSearchRoutes()
    },
    {
      path: "chat/inbox/*",
      element: /* @__PURE__ */ jsx37("div", { children: context.session?.employerId && /* @__PURE__ */ jsx37(
        RecruitConversationsChat,
        {
          employerId: context.session?.employerId
        }
      ) })
    },
    {
      path: "projects/*",
      element: /* @__PURE__ */ jsx37(OutletRoute7, {}),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => /* @__PURE__ */ jsx37(BreadcrumbLink3, { to: "/employers/app/projects", label: "Projects" })
      },
      children: createProjectsRoutes("employers", environment, context)
    },
    {
      path: "talent-pools/*",
      element: /* @__PURE__ */ jsx37(OutletRoute7, {}),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => /* @__PURE__ */ jsx37(
          BreadcrumbLink3,
          {
            to: "/employers/app/talent-pools",
            label: "Talent Pools"
          }
        )
      },
      children: createTalentPoolsRoutes("employers", environment, context)
    },
    {
      path: "offers/*",
      element: /* @__PURE__ */ jsx37(OutletRoute7, {}),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => /* @__PURE__ */ jsx37(BreadcrumbLink3, { to: "/employers/app/offers", label: "Offers" })
      },
      children: createOffersRoutes(environment, context)
    },
    {
      path: "recommendations/*",
      element: /* @__PURE__ */ jsx37(RecommendationsRoute, {}),
      children: createRecommendationsRoutes(environment, context),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => /* @__PURE__ */ jsx37(BreadcrumbLink3, { to: "/employers/app/offers", label: "Offers" })
      }
    },
    {
      path: "application-history/*",
      element: /* @__PURE__ */ jsx37("div", { children: "application history" }),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => /* @__PURE__ */ jsx37(BreadcrumbLink3, { to: "/employers/app/offers", label: "Offers" })
      }
    },
    {
      path: "interviews/*",
      element: /* @__PURE__ */ jsx37(OutletRoute7, {}),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => /* @__PURE__ */ jsx37(BreadcrumbLink3, { to: "/employers/app/offers", label: "Offers" })
      },
      children: createInterviewsRoutes(environment, context)
    },
    {
      path: "vacancies/*",
      element: /* @__PURE__ */ jsx37(
        VacancyApplicationSearchFacetsContext.Provider,
        {
          value: [
            { key: "skills", title: "Skills" },
            { key: "Companies", title: "Companies" },
            { key: "Industries", title: "Industries" },
            { key: "Education", title: "Education" },
            {
              key: "Skill Groups",
              title: "Skill Groups"
            },
            {
              key: "Application Created Date",
              title: "Application Created Date"
            },
            { key: "Application State", title: "Application State" },
            {
              key: "Industry Experience Relevance",
              title: "Industry Experience Relevance"
            },
            {
              key: "Industry Recency Relevance",
              title: "Industry Recency Relevance"
            },
            {
              key: "Job Experience Relevance",
              title: "Job Experience Relevance"
            },
            { key: "Job Recency Relevance", title: "Job Recency Relevance" }
          ],
          children: /* @__PURE__ */ jsx37(OutletRoute7, {})
        }
      ),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => {
          return /* @__PURE__ */ jsx37(BreadcrumbLink3, { to: "/employers/app/vacancies", label: "Vacancies" });
        }
      },
      children: createVacanciesRoutes(environment, context)
    },
    {
      path: "applications/*",
      element: /* @__PURE__ */ jsx37(OutletRoute7, {}),
      handle: {
        // you can put whatever you want on a route handle
        // here we use "crumb" and return some elements,
        // this is what we'll render in the breadcrumbs
        // for this route
        crumb: () => /* @__PURE__ */ jsx37(
          BreadcrumbLink3,
          {
            to: "/employers/app/applications",
            label: "Applications"
          }
        )
      },
      children: createApplicationsRoutes(environment, context)
    }
  ];
};
var AppPageComponent = () => {
  const data = useLazyLoadQuery4(
    queryDef7,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  const location = useLocation3();
  const sidebarNavigation = [
    createLinkState3(location, "Account", `account`, UserCircleIcon2),
    createLinkState3(location, "Projects", `projects`, InboxStackIcon),
    createLinkState3(
      location,
      "Vacancies",
      `vacancies`,
      ClipboardDocumentCheckIcon2
    ),
    createLinkState3(location, "Applications", `applications`, UsersIcon4),
    createLinkState3(location, "Talent Pools", `talent-pools`, UserGroupIcon3),
    createLinkState3(
      location,
      "Inbox",
      `chat/inbox`,
      ChatBubbleOvalLeftEllipsisIcon
    ),
    createLinkState3(location, "Interviews", `interviews`, BriefcaseIcon2),
    // createLinkState(location, 'Offers', `offers`, SwatchIcon),
    createLinkState3(location, "Settings", `settings/list`, Cog8ToothIcon),
    createLinkState3(
      location,
      "Profile Search",
      `profile-search`,
      MagnifyingGlassIcon
    ),
    createLinkState3(
      location,
      "Recommendations",
      `recommendations`,
      LightBulbIcon
    )
  ];
  const trayNavigation = [
    createLinkState3(
      location,
      "Projects",
      `projects`,
      ClipboardDocumentCheckIcon2
    ),
    createLinkState3(location, "Vacancies", `vacancies`, UserGroupIcon3),
    createLinkState3(location, "Applications", `applications`, InboxStackIcon),
    createLinkState3(
      location,
      "Inbox",
      `chat/inbox`,
      ChatBubbleOvalLeftEllipsisIcon
    )
  ];
  const auth = useAuth2();
  const onSignOut = useCallback9(async () => {
    await auth?.signOutRedirect();
  }, [auth]);
  const userNavigation = [
    { name: "Your Profile", to: "/employers/app/account", icon: UserIcon2 },
    {
      name: "Sign out",
      to: ".",
      icon: ArrowRightOnRectangleIcon,
      onClick: onSignOut
    }
  ];
  const { accountEmployerUserViewer: account } = data;
  if (!account) {
    window.location.reload();
    return /* @__PURE__ */ jsx37("div", { children: "No Account Data Found, Please Wait...." });
  }
  return /* @__PURE__ */ jsx37(ErrorBoundary9, { fallback: /* @__PURE__ */ jsx37(AppErrorPage, {}), children: /* @__PURE__ */ jsx37(
    Shell,
    {
      accountLink: "/employers/app/account",
      sidebarNavigation,
      trayNavigation,
      userNavigation,
      accountInfo: {
        firstName: account.firstName,
        lastName: account.lastName
      },
      children: /* @__PURE__ */ jsx37(Outlet11, {})
    }
  ) });
};
var withUserId = (Component) => {
  return function WrappedComponent(props) {
    const session = useUserSessionContext7();
    const auth = useAuth2();
    const setEmployer = useSetAtom(employerIdAtom);
    useEffect4(() => {
      if (!auth || !auth.userData || !session || !session.employerId) {
        return;
      }
      setEmployer(session.employerId);
    }, [setEmployer, auth]);
    if (session == null) {
      return /* @__PURE__ */ jsx37(EdSkeleton21, {});
    }
    return createElement(Component, { ...props, userId: session.userId });
  };
};
var AppEmployersSecureLayout = withUserId(AppPageComponent);

// src/navigate/NavigatePage.tsx
import { useEffect as useEffect5, useState as useState3 } from "react";
import { useNavigate as useNavigate8, useSearchParams as useSearchParams2 } from "react-router-dom";
import { useLogger as useLogger2, useSetNextLocation } from "shared-lib";
import { Button as Button7 } from "shared-ui";
import { ElevateAccountTypes, Tenant, useOIDC } from "app-core";
import { jsx as jsx38, jsxs as jsxs17 } from "react/jsx-runtime";
var NavigatePage = () => {
  const [log] = useLogger2();
  const [error, setError] = useState3(null);
  const [impersonate, setImpersonate] = useState3(null);
  const navigate = useNavigate8();
  const setNextLocation = useSetNextLocation();
  const [context, setContext] = useState3(null);
  const { signInOTP, signInAs, signIn } = useOIDC();
  const [searchParams] = useSearchParams2();
  useEffect5(() => {
    const action = searchParams.get("action");
    const parameters = searchParams.get("data");
    const otac = searchParams.get("otac") || void 0;
    const params = parameters ? JSON.parse(decodeURI(parameters)) : null;
    log(`Employers Nav: action: ${action} params: ${parameters}`);
    switch (action) {
      case "impersonate": {
        if (params) {
          const { accountId, token } = params;
          if (accountId && token) {
            setImpersonate(params);
          } else {
            setError("Could Not Load Impersonation Data");
          }
        }
        break;
      }
      case "application": {
        if (params) {
          const returnLocation = `../app/applications/${params.id}/info`;
          setContext({ otacCode: otac, returnUrl: returnLocation });
        } else {
          setContext({ otacCode: otac });
        }
        break;
      }
      default: {
        setContext({ otacCode: otac });
        break;
      }
    }
  }, [searchParams]);
  async function onImpersonation() {
    log(`Employers Nav Impersonate: ${JSON.stringify(impersonate)}`);
    if (impersonate == null) {
      return;
    }
    const { accountId, token } = impersonate;
    await signInAs(
      accountId,
      Tenant.Employer,
      ElevateAccountTypes.Employer,
      token
    );
  }
  async function onSignIn() {
    if (context && context.otacCode) {
      await signInOTP(context.otacCode);
    } else {
      await signIn();
    }
  }
  if (impersonate) {
    return /* @__PURE__ */ jsx38("div", { className: "p-4", children: /* @__PURE__ */ jsx38(Button7, { color: "primary", clicked: onImpersonation, children: "Impersonate & Sign In" }) });
  }
  if (context && !context.otacCode) {
    return /* @__PURE__ */ jsx38("div", { children: /* @__PURE__ */ jsx38(
      "button",
      {
        onClick: () => {
          navigate("/portal/employers");
        },
        children: "Login"
      }
    ) });
  } else {
    return /* @__PURE__ */ jsxs17("div", { children: [
      error && /* @__PURE__ */ jsx38("div", { className: "m-8 border bg-white", children: error }),
      /* @__PURE__ */ jsx38("button", { onClick: onSignIn, children: "Login" })
    ] });
  }
};

// src/landing/HomePage.tsx
import { Button as Button8, EdCard, EdLink as EdLink3, Size as Size4 } from "shared-ui";
import { useIsLoggedIn, useOIDC as useOIDC2 } from "app-core";
import { jsx as jsx39, jsxs as jsxs18 } from "react/jsx-runtime";
var HomePage = () => {
  const isSignedIn = useIsLoggedIn();
  const { signIn } = useOIDC2();
  async function onSignIn() {
    await signIn("app");
  }
  return /* @__PURE__ */ jsx39("div", { className: "container mx-auto flex flex-grow justify-center sm:my-16", children: /* @__PURE__ */ jsx39("div", { className: "flex h-full max-w-lg flex-grow bg-white", children: /* @__PURE__ */ jsxs18(EdCard, { className: "justify-center p-10 text-center", children: [
    /* @__PURE__ */ jsx39("h2", { className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: /* @__PURE__ */ jsx39("span", { className: "block", children: "Employers" }) }),
    /* @__PURE__ */ jsx39("div", { className: "pt-4", children: /* @__PURE__ */ jsx39("div", { className: "text-md text-primary-500 font-medium", children: "Start changing your work life today" }) }),
    /* @__PURE__ */ jsx39("div", { className: "mt-8 flex justify-center", children: isSignedIn ? /* @__PURE__ */ jsx39(EdLink3, { href: "app", name: "app-link", children: /* @__PURE__ */ jsx39("div", { className: "bg-primary-100 text-primary-700 hover:bg-primary-200 inline-flex items-center justify-center rounded-md border border-transparent px-5 py-3 text-base font-medium", children: "Start Now" }) }) : /* @__PURE__ */ jsxs18("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsx39(Button8, { color: "primary", size: Size4.xl, onClick: onSignIn, children: /* @__PURE__ */ jsx39("div", { className: "mx-1 flex items-center gap-1 px-5", children: /* @__PURE__ */ jsx39("div", { className: "whitespace-nowrap ", children: "Sign In" }) }) }),
      /* @__PURE__ */ jsx39(EdLink3, { href: "pub/signup", name: "signup-link", children: /* @__PURE__ */ jsx39(
        Button8,
        {
          color: "transparent",
          size: Size4.xl,
          className: "border border-black",
          children: /* @__PURE__ */ jsx39("div", { className: "mx-1 flex items-center gap-1 px-5", children: /* @__PURE__ */ jsx39("div", { className: "whitespace-nowrap ", children: "Sign Up" }) })
        }
      ) })
    ] }) })
  ] }) }) });
};

// src/AppEmployerAuthGuard.tsx
import { AuthGuard } from "app-core";

// src/lib/UseRouteRegistry.ts
import { useEffect as useEffect6 } from "react";
import { useLocation as useLocation4 } from "react-router-dom";
import { useSetLinkRegistry } from "app-core";
var employerLinkRegistry = class {
  constructor(location) {
    this.location = location;
  }
  applicationLink(code) {
    return `/employers/app/applications/application/${code}`;
  }
};
function useRouteRegistry() {
  const location = useLocation4();
  const setRegistry = useSetLinkRegistry();
  useEffect6(() => {
    console.log("useRouteRegistry");
    const registry = new employerLinkRegistry(location);
    setRegistry(registry);
  }, []);
}

// src/lib/useUserManager.ts
import { useMemo as useMemo2 } from "react";
import { ElevateAccountTypes as ElevateAccountTypes2, Tenant as Tenant2 } from "app-core";

// src/config/config.ts
import { useContext, useMemo } from "react";
import {
  loadEnvironmentConfig,
  GlobalSettingsContext,
  PortalApps
} from "shared-lib";

// src/config/oidc.config.ts
import { ElevateScopes } from "app-core";
var oidc_config_default = {
  responseType: "id_token token",
  acrValues: "tenant:employer",
  clientId: "employers.web",
  scope: `openid profile email ${ElevateScopes.EmployersScope} ${ElevateScopes.NotificationsScope} ${ElevateScopes.RecruitApiScope}  ${ElevateScopes.EventTrackingApiScope} ${ElevateScopes.CompaniesScope}`
};

// src/config/config.ts
function useConfig() {
  const settings = useContext(GlobalSettingsContext);
  const environmentConfig = useMemo(() => {
    return loadEnvironmentConfig(settings, PortalApps.Employers);
  }, [settings]);
  const config = useMemo(() => {
    return {
      ...oidc_config_default,
      ...environmentConfig
    };
  }, [oidc_config_default, environmentConfig]);
  return config;
}

// src/lib/useUserManager.ts
function useAuthConfig() {
  const config = useConfig();
  const signoutRedirectUri = `${window.location.protocol}//${window.location.host}/portal/employers`;
  const signoutLink = `${window.location.protocol}//${window.location.host}/elevate.identity/core`;
  const authConfig = useMemo2(() => {
    return {
      ...config,
      autoSignIn: false,
      accountType: ElevateAccountTypes2.Employer,
      signoutRedirectUri,
      signoutLink,
      tenant: Tenant2.Employer,
      onSetUserData: async () => {
        window.location.hash = "";
      }
    };
  }, [config]);
  return authConfig;
}

// src/AppEmployerAuthGuard.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var AppEmployerAuthGuard = ({ children }) => {
  const authConfig = useAuthConfig();
  return /* @__PURE__ */ jsx40(AuthGuard, { ...authConfig, children });
};

// src/AppEmployerRoutes.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var AppEmployerRoutes = (environment, context) => {
  return [
    {
      path: "signin-oidc/*",
      element: /* @__PURE__ */ jsx41(SignInLoader, {}),
      errorElement: /* @__PURE__ */ jsx41(ErrorContainer2, {})
    },
    {
      path: "signout-oidc",
      element: /* @__PURE__ */ jsx41(Navigate13, { replace: true, to: "/employers" }),
      errorElement: /* @__PURE__ */ jsx41(ErrorContainer2, {})
    },
    {
      path: "nav/*",
      element: /* @__PURE__ */ jsx41(NavigatePage, {}),
      errorElement: /* @__PURE__ */ jsx41(ErrorContainer2, {})
    },
    {
      path: "pub/*",
      element: /* @__PURE__ */ jsx41(AppEmployersPublicLayout, {}),
      errorElement: /* @__PURE__ */ jsx41(ErrorContainer2, {}),
      children: AppEmployersPublicRoutes
    },
    {
      path: "app/*",
      element: /* @__PURE__ */ jsx41(AppEmployerAuthGuard, { children: /* @__PURE__ */ jsx41(AppEmployersSecureLayout, {}) }),
      errorElement: /* @__PURE__ */ jsx41(ErrorContainer2, {}),
      children: AppEmployersSecureRoutes(environment, context),
      handle: {}
    },
    {
      path: "debugger/*",
      element: /* @__PURE__ */ jsx41(DebuggerConfig, { onDone: () => console.log(``) }),
      errorElement: /* @__PURE__ */ jsx41(ErrorContainer2, {})
    },
    {
      index: true,
      element: /* @__PURE__ */ jsx41(HomePage, {}),
      errorElement: /* @__PURE__ */ jsx41(ErrorContainer2, {})
    }
  ];
};

// src/AppEmployers.tsx
import { useEffect as useEffect7 } from "react";
import { Outlet as Outlet12 } from "react-router-dom";
import { Suspense as Suspense23 } from "shared-ui";
import { Loading as Loading2 } from "shared-ui";
import {
  AuthProvider,
  setAppContext,
  Tenant as Tenant3,
  useOIDC as useOIDC3
} from "app-core";
import { jsx as jsx42 } from "react/jsx-runtime";
var AppEmployers = () => {
  const oidc = useOIDC3();
  const authConfig = useAuthConfig();
  useRouteRegistry();
  useChatwoot();
  useEffect7(() => {
    let isMounted = true;
    const app = {
      tenant: Tenant3.Employer
    };
    setAppContext(app);
    async function checkSessionAsync() {
      oidc.setTenant(Tenant3.Employer);
      await oidc.checkSession();
    }
    checkSessionAsync();
    return () => {
      isMounted = false;
    };
  }, [oidc]);
  return /* @__PURE__ */ jsx42(AuthProvider, { ...authConfig, children: /* @__PURE__ */ jsx42("div", { className: "flex min-h-screen flex-col", children: /* @__PURE__ */ jsx42(Suspense23, { fallback: /* @__PURE__ */ jsx42(Loading2, { label: "Almost there..." }), children: /* @__PURE__ */ jsx42(Outlet12, {}) }) }) });
};
export {
  AccountLayout,
  AccountPage,
  AccountsLayout,
  AppEmployerRoutes,
  AppEmployers,
  AppEmployersSecureLayout,
  AppEmployersSecureRoutes,
  ErrorPage,
  InterviewsListRoute,
  InterviewsRoute,
  OfferRoute,
  SignInLoader,
  VacanciesListRoute,
  VacancyCreatePage,
  createAccountRoutes,
  createInterviewsRoutes,
  createVacanciesRoutes,
  useChatwoot
};
//# sourceMappingURL=index.mjs.map